(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8026],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js


function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js
'use client';



const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};
const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 44267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardContent_CardContent; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/cardContentClasses.js


function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/CardContent.js
'use client';



const _excluded = ["className", "component"];








const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};
const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiCardContent'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);

/***/ }),

/***/ 2788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es; }
});

// UNUSED EXPORTS: inlineMock

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(98924);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(80334);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(42550);
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/Context.js

var OrderContext = /*#__PURE__*/react.createContext(null);
/* harmony default export */ var Context = (OrderContext);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(8410);
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/useDom.js






var EMPTY_LIST = [];

/**
 * Will add `div` to document. Nest call will keep order
 * @param render Render DOM in document
 */
function useDom(render, debug) {
  var _React$useState = react.useState(function () {
      if (!(0,canUseDom/* default */.Z)()) {
        return null;
      }
      var defaultEle = document.createElement('div');
      if (false) {}
      return defaultEle;
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 1),
    ele = _React$useState2[0];

  // ========================== Order ==========================
  var appendedRef = react.useRef(false);
  var queueCreate = react.useContext(Context);
  var _React$useState3 = react.useState(EMPTY_LIST),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    queue = _React$useState4[0],
    setQueue = _React$useState4[1];
  var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function (appendFn) {
    setQueue(function (origin) {
      var newQueue = [appendFn].concat((0,toConsumableArray/* default */.Z)(origin));
      return newQueue;
    });
  });

  // =========================== DOM ===========================
  function append() {
    if (!ele.parentElement) {
      document.body.appendChild(ele);
    }
    appendedRef.current = true;
  }
  function cleanup() {
    var _ele$parentElement;
    (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 ? void 0 : _ele$parentElement.removeChild(ele);
    appendedRef.current = false;
  }
  (0,useLayoutEffect/* default */.Z)(function () {
    if (render) {
      if (queueCreate) {
        queueCreate(append);
      } else {
        append();
      }
    } else {
      cleanup();
    }
    return cleanup;
  }, [render]);
  (0,useLayoutEffect/* default */.Z)(function () {
    if (queue.length) {
      queue.forEach(function (appendFn) {
        return appendFn();
      });
      setQueue(EMPTY_LIST);
    }
  }, [queue]);
  return [ele, mergedQueueCreate];
}
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/dynamicCSS.js
var dynamicCSS = __webpack_require__(44958);
// EXTERNAL MODULE: ./node_modules/rc-util/es/getScrollBarSize.js
var getScrollBarSize = __webpack_require__(74204);
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/util.js
/**
 * Test usage export. Do not use in your production
 */
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/useScrollLocker.js






var UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var uuid = 0;
function useScrollLocker(lock) {
  var mergedLock = !!lock;
  var _React$useState = react.useState(function () {
      uuid += 1;
      return "".concat(UNIQUE_ID, "_").concat(uuid);
    }),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 1),
    id = _React$useState2[0];
  (0,useLayoutEffect/* default */.Z)(function () {
    if (mergedLock) {
      var scrollbarSize = (0,getScrollBarSize/* getTargetScrollBarSize */.o)(document.body).width;
      var isOverflow = isBodyOverflowing();
      (0,dynamicCSS/* updateCSS */.hq)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : '', "\n}"), id);
    } else {
      (0,dynamicCSS/* removeCSS */.jL)(id);
    }
    return function () {
      (0,dynamicCSS/* removeCSS */.jL)(id);
    };
  }, [mergedLock, id]);
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/mock.js
var inline = false;
function inlineMock(nextInline) {
  if (typeof nextInline === 'boolean') {
    inline = nextInline;
  }
  return inline;
}
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/Portal.js










var getPortalContainer = function getPortalContainer(getContainer) {
  if (getContainer === false) {
    return false;
  }
  if (!(0,canUseDom/* default */.Z)() || !getContainer) {
    return null;
  }
  if (typeof getContainer === 'string') {
    return document.querySelector(getContainer);
  }
  if (typeof getContainer === 'function') {
    return getContainer();
  }
  return getContainer;
};
var Portal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var open = props.open,
    autoLock = props.autoLock,
    getContainer = props.getContainer,
    debug = props.debug,
    _props$autoDestroy = props.autoDestroy,
    autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy,
    children = props.children;
  var _React$useState = react.useState(open),
    _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
    shouldRender = _React$useState2[0],
    setShouldRender = _React$useState2[1];
  var mergedRender = shouldRender || open;

  // ========================= Warning =========================
  if (false) {}

  // ====================== Should Render ======================
  react.useEffect(function () {
    if (autoDestroy || open) {
      setShouldRender(open);
    }
  }, [open, autoDestroy]);

  // ======================== Container ========================
  var _React$useState3 = react.useState(function () {
      return getPortalContainer(getContainer);
    }),
    _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
    innerContainer = _React$useState4[0],
    setInnerContainer = _React$useState4[1];
  react.useEffect(function () {
    var customizeContainer = getPortalContainer(getContainer);

    // Tell component that we check this in effect which is safe to be `null`
    setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
  });
  var _useDom = useDom(mergedRender && !innerContainer, debug),
    _useDom2 = (0,slicedToArray/* default */.Z)(_useDom, 2),
    defaultContainer = _useDom2[0],
    queueCreate = _useDom2[1];
  var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;

  // ========================= Locker ==========================
  useScrollLocker(autoLock && open && (0,canUseDom/* default */.Z)() && (mergedContainer === defaultContainer || mergedContainer === document.body));

  // =========================== Ref ===========================
  var childRef = null;
  if (children && (0,es_ref/* supportRef */.Yr)(children) && ref) {
    var _ref = children;
    childRef = _ref.ref;
  }
  var mergedRef = (0,es_ref/* useComposeRef */.x1)(childRef, ref);

  // ========================= Render ==========================
  // Do not render when nothing need render
  // When innerContainer is `undefined`, it may not ready since user use ref in the same render
  if (!mergedRender || !(0,canUseDom/* default */.Z)() || innerContainer === undefined) {
    return null;
  }

  // Render inline
  var renderInline = mergedContainer === false || inlineMock();
  var reffedChildren = children;
  if (ref) {
    reffedChildren = /*#__PURE__*/react.cloneElement(children, {
      ref: mergedRef
    });
  }
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: queueCreate
  }, renderInline ? reffedChildren : /*#__PURE__*/(0,react_dom.createPortal)(reffedChildren, mergedContainer));
});
if (false) {}
/* harmony default export */ var es_Portal = (Portal);
;// CONCATENATED MODULE: ./node_modules/@rc-component/portal/es/index.js



/* harmony default export */ var es = (es_Portal);

/***/ }),

/***/ 8745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ withPureRenderTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var rc_util_es_hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21770);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83760);
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53124);
"use client";




function withPureRenderTheme(Component) {
  return props => (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_config_provider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    theme: {
      token: {
        motion: false,
        zIndexPopupBase: 0
      }
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({}, props))));
}
/* istanbul ignore next */
const genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls) => {
  const PurePanel = props => {
    const {
      prefixCls: customizePrefixCls,
      style
    } = props;
    const holderRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
    const [popupHeight, setPopupHeight] = react__WEBPACK_IMPORTED_MODULE_0__.useState(0);
    const [popupWidth, setPopupWidth] = react__WEBPACK_IMPORTED_MODULE_0__.useState(0);
    const [open, setOpen] = (0,rc_util_es_hooks_useMergedState__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(false, {
      value: props.open
    });
    const {
      getPrefixCls
    } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_config_provider__WEBPACK_IMPORTED_MODULE_3__/* .ConfigContext */ .E_);
    const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
      // We do not care about ssr
      setOpen(true);
      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(entries => {
          const element = entries[0].target;
          setPopupHeight(element.offsetHeight + 8);
          setPopupWidth(element.offsetWidth);
        });
        const interval = setInterval(() => {
          var _a;
          const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
          const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
          if (popup) {
            clearInterval(interval);
            resizeObserver.observe(popup);
          }
        }, 10);
        return () => {
          clearInterval(interval);
          resizeObserver.disconnect();
        };
      }
    }, [prefixCls]);
    let mergedProps = Object.assign(Object.assign({}, props), {
      style: Object.assign(Object.assign({}, style), {
        margin: 0
      }),
      open,
      visible: open,
      getPopupContainer: () => holderRef.current
    });
    if (postProps) {
      mergedProps = postProps(mergedProps);
    }
    if (alignPropName) {
      Object.assign(mergedProps, {
        [alignPropName]: {
          overflow: {
            adjustX: false,
            adjustY: false
          }
        }
      });
    }
    const mergedStyle = {
      paddingBottom: popupHeight,
      position: 'relative',
      minWidth: popupWidth
    };
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      ref: holderRef,
      style: mergedStyle
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, Object.assign({}, mergedProps)));
  };
  return withPureRenderTheme(PurePanel);
};
/* harmony default export */ __webpack_exports__["Z"] = (genPurePanel);

/***/ }),

/***/ 93590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ initMotion; }
/* harmony export */ });
const initMotionCommon = duration => ({
  animationDuration: duration,
  animationFillMode: 'both'
});
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const initMotionCommonLeave = duration => ({
  animationDuration: duration,
  animationFillMode: 'both'
});
const initMotion = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false) => {
  const sameLevelPrefix = sameLevel ? '&' : '';
  return {
    [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon(duration)), {
      animationPlayState: 'paused'
    }),
    [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(duration)), {
      animationPlayState: 'paused'
    }),
    [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
      animationName: inKeyframes,
      animationPlayState: 'running'
    },
    [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
      animationName: outKeyframes,
      animationPlayState: 'running',
      pointerEvents: 'none'
    }
  };
};

/***/ }),

/***/ 91015:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return __webpack_require__(78603);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1954);
// ** Icon Imports


const IconifyIcon = (param)=>{
    let { icon , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        icon: icon,
        fontSize: "1.5rem",
        ...rest
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconifyIcon);


/***/ }),

/***/ 80671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);



const NoData = ()=>{
    var ref, ref1, ref2;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const [isDisplay, setIsDisplay] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const email = ((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.email) || "";
    const allDeviceUser = JSON.parse(localStorage.getItem("allDeviceUser")) || [];
    const time = (allDeviceUser === null || allDeviceUser === void 0 ? void 0 : (ref2 = allDeviceUser[0]) === null || ref2 === void 0 ? void 0 : ref2.createdAt) || null;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!email || !time) return;
        const inputTime = new Date(time).getTime();
        const now = Date.now();
        const oneHourAgo = now - 60 * 60 * 1000;
        const shouldDisplay = inputTime > oneHourAgo;
        setIsDisplay(shouldDisplay);
        localStorage.setItem("isDisplay-".concat(email), JSON.stringify(shouldDisplay));
    }, [
        email,
        time
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!email) return;
        const stored = localStorage.getItem("isDisplay-".concat(email));
        setIsDisplay(stored === "true");
    }, [
        email
    ]);
    const NoDisplay = ()=>{
        setIsDisplay(false);
        localStorage.setItem("isDisplay-".concat(email), JSON.stringify(false));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isDisplay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "[box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white p-5 pt-1 mb-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "text-[28px] h-[30px] smjs:translate-y-[20px]",
                        onClick: ()=>NoDisplay(),
                        children: "\xd7"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/welcome.svg",
                            width: 32,
                            height: 32,
                            alt: "welcome",
                            className: "w-[32px] h-[32px]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ml-5 smjs:pr-6",
                            children: t("Welcome We")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoData);


/***/ }),

/***/ 14326:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const navigation = ()=>{
    return [
        {
            "title": "Dashboard",
            "icon": "/images/navigation/dashboard.svg",
            "path": "/dashboard"
        },
        {
            "sectionTitle": "Basic"
        },
        {
            "title": "Photo",
            "icon": "/images/navigation/photo.svg",
            "path": "/photos",
            "category": "ALBUM_SUMMARY",
            "eventName": "Click_Photo"
        },
        {
            "title": "Video",
            "icon": "/images/navigation/video.svg",
            "path": "/video",
            "category": "ALBUM_DETAIL",
            "eventName": "Click_Video"
        },
        {
            "title": "GPS location",
            "icon": "/images/navigation/gps-location.svg",
            "path": "/locations/gps",
            "category": "LOCATION_DEVICES",
            "eventName": "Click_GPSlocation"
        },
        {
            "title": "Contact",
            "icon": "/images/navigation/contact.svg",
            "path": "/contacts",
            "category": "CONTACT",
            "eventName": "Click_Contact"
        },
        {
            "title": "Mail",
            "icon": "/images/navigation/mail.svg",
            "path": "/mail",
            "eventName": "Click_Mail"
        },
        {
            "title": "iCloud drive",
            "icon": "/images/navigation/icloud-drive.svg",
            "path": "/i-cloud-drive",
            "category": "ICLOUD_DRIVE_DIR",
            "eventName": "Click_iClouddrive"
        },
        {
            "title": "Note",
            "icon": "/images/navigation/note.svg",
            "path": "/notes",
            "category": "NOTE",
            "eventName": "Click_Note"
        },
        {
            "title": "Calendar",
            "icon": "/images/navigation/calendar.svg",
            "path": "/calendars",
            "category": "CALENDAR",
            "eventName": "Click_Calendar"
        },
        {
            "title": "Reminder",
            "icon": "/images/navigation/reminder.svg",
            "path": "/reminders",
            "category": "REMINDER_SUMMARY",
            "eventName": "Click_Reminder"
        },
        {
            "sectionTitle": "EXTREME"
        },
        {
            "title": "Text message",
            "icon": "/images/navigation/text-message.svg",
            "path": "/text-messages",
            "category": "SMS_CHAT_SUMMARY",
            "eventName": "Click_Textmessage"
        },
        {
            "title": "Call",
            "icon": "/images/navigation/call.svg",
            "path": "/calls",
            "category": "",
            "eventName": "Click_Call"
        },
        {
            "title": "Voicemail",
            "icon": "/images/navigation/voicemail.svg",
            "path": "/voicemail",
            "category": "",
            "eventName": "Click_Voicemail"
        },
        {
            "title": "WhatsApp",
            "icon": "/images/navigation/whatsapp.svg",
            "path": "/whatsapp",
            "category": "WHATSAPP_CHAT_SUMMARY",
            "eventName": "Click_WhatsApp"
        },
        {
            "title": "WA BUSINESS",
            "icon": "/images/navigation/wa-business.svg",
            "path": "/wa-business",
            "category": "WHATSAPP_CHAT_SUMMARY",
            "eventName": "Click_WABusiness"
        },
        {
            "title": "LINE",
            "icon": "/images/navigation/line.svg",
            "path": "/line",
            "category": "LINE_CHAT_SUMMARY",
            "eventName": "Click_LINE"
        },
        {
            "title": "Kik",
            "icon": "/images/navigation/kik.svg",
            "path": "/kik",
            "category": "KIK_CHAT_SUMMARY",
            "eventName": "Click_Kik"
        },
        {
            "title": "WeChat",
            "icon": "/images/navigation/wechat.svg",
            "path": "/we-chat",
            "category": "WECHAT_CHAT_SUMMARY",
            "eventName": "Click_WeChat"
        },
        {
            "title": "Messenger",
            "icon": "/images/navigation/messenger.svg",
            "path": "/messenger",
            "category": "FACEBOOK_MESSENGER_SUMMARY",
            "eventName": "Click_Messenger"
        },
        {
            "title": "Browser history",
            "icon": "/images/navigation/browser-history.svg",
            "path": "/browser-history",
            "category": "SAFARI_HISTORY",
            "eventName": "Click_Browserhistory"
        },
        {
            "title": "Browser bookmark",
            "icon": "/images/navigation/browser-bookmark.svg",
            "path": "/browser-bookmark",
            "category": "SAFARI_BOOKMARK",
            "eventName": "Click_Browserbookmark"
        },
        {
            "title": "Installed app",
            "icon": "/images/navigation/installed-app.svg",
            "path": "/apps",
            "category": "INSTALLED_APP",
            "eventName": "Click_Installedapp"
        },
        {
            "title": "Wi-Fi network",
            "icon": "/images/navigation/wi-fi-network.svg",
            "path": "/wifi-networks",
            "category": "WIFI",
            "eventName": "Click_Wifinetwork"
        },
        {
            "title": "Skype",
            "icon": "/images/navigation/skype.svg",
            "path": "/skype",
            "category": "skype",
            "eventName": "Click_Skype"
        },
        {
            "title": "Teams",
            "icon": "/images/navigation/teams.svg",
            "path": "/teams",
            "category": "Teams",
            "eventName": "Click_Teams"
        },
        {
            "title": "Telegram",
            "icon": "/images/navigation/telegram.svg",
            "path": "/telegram",
            "category": "Telegram",
            "eventName": "Click_Telegram"
        },
        {
            "title": "Snapchat",
            "icon": "/images/navigation/snapchat.svg",
            "path": "/snapchat",
            "category": "Snapchat",
            "eventName": "Click_Snapchat"
        },
        {
            "title": "Instagram",
            "icon": "/images/navigation/instagram.svg",
            "path": "/instagram",
            "category": "Instagram",
            "eventName": "Click_Instagram"
        },
        {
            "title": "Facetime",
            "icon": "/images/navigation/facetime.svg",
            "path": "/facetime",
            "category": "Facetime",
            "eventName": "Click_Facetime"
        },
        {
            "title": "My account",
            "icon": "/images/navigation/my-account.svg",
            "path": "/pages/account-settings/account",
            "eventName": "Click_Myaccount"
        }
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (navigation);


/***/ }),

/***/ 78603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_dashboard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card_Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent_CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 27 modules
var modal = __webpack_require__(60770);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 3 modules
var es_checkbox = __webpack_require__(84567);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 10 modules
var es_button = __webpack_require__(75398);
// EXTERNAL MODULE: ./src/navigation/vertical/index.js
var vertical = __webpack_require__(14326);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/@core/components/bind-illustrate/index.js










/* harmony default export */ var bind_illustrate = ((BindIllustrate)=>{
    const [isModalOpen, setIsModalOpen] = useState(true);
    const showModal = ()=>{
        setIsModalOpen(true);
    };
    const handleCancel = ()=>{
        setIsModalOpen(false);
    };
    const router = useRouter();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Modal, {
            className: "illustrate",
            open: isModalOpen,
            onCancel: handleCancel,
            footer: [],
            width: 500,
            closable: false,
            children: /*#__PURE__*/ _jsx("div", {
                style: {
                    textAlign: "center"
                },
                children: /*#__PURE__*/ _jsx("p", {
                    style: {
                        fontSize: "20px",
                        textAlign: "center"
                    },
                    children: "You have completed the device connection, please wait patiently for the data to be sent back."
                })
            })
        })
    });
});

// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./src/utils/updateDeviceCredentials.js
var utils_updateDeviceCredentials = __webpack_require__(80122);
// EXTERNAL MODULE: ./src/components/ios-extreme/icloud-locked/useIcloudLockedFlow.js + 3 modules
var icloud_locked_useIcloudLockedFlow = __webpack_require__(82000);
// EXTERNAL MODULE: ./src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify.js
var icloud_locked_useIcloudCredentialReverify = __webpack_require__(56148);
// EXTERNAL MODULE: ./src/utils/icloudLoginResult.js
var icloudLoginResult = __webpack_require__(83469);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
// EXTERNAL MODULE: ./src/@api/android.js
var android = __webpack_require__(19630);
;// CONCATENATED MODULE: ./src/@core/components/user-verify/index.js


















const CodeBox = dynamic_default()(__webpack_require__.e(/* import() */ 9069).then(__webpack_require__.t.bind(__webpack_require__, 69069, 23)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69069)
            ]
    },
    ssr: false //这个要加上,禁止使用 SSR
});



const steps = [
    {
        title: "Connect"
    },
    {
        title: "Verification"
    }
];
const UserVerify = ()=>{
    const dispatch = useDispatch();
    const [messageApi, contextHolder] = message.useMessage();
    const { t  } = useTranslation("common");
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [defaultSmsPhone, setDefaultSmsPhone] = useState({});
    const [smsPhoneList, setSmsPhoneList] = useState([]);
    const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true);
    const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true);
    const [smsId, setSmsId] = useState("");
    const [activeKey, setActiveKey] = useState("1");
    const [smsErrorText, setSmsErrorText] = useState("") // icloud没有绑定手机号错误提示文案
    ;
    const [illustrate, setIllustrate] = useState(false);
    const showModal = ()=>{
        setIsModalOpen(true);
    };
    const handleCancel = ()=>{
        setIsModalOpen(false);
    };
    const onChange = async (key)=>{
        if (key == 2) {
            let mode = 1;
            let sms = await bySms({
                mode: mode,
                username: useUserName,
                password: usePassWord
            });
            let result = await authInfo({
                mode: mode,
                username: useUserName,
                password: usePassWord
            });
            setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber);
            setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || "0");
            let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map((item)=>{
                return {
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                };
            });
            setSmsPhoneList(mapData);
            setSmsPhoneListDisabled(false);
            setSmsPhoneListLoading(false);
        }
    };
    const [current, setCurrent] = useState(0);
    const items = steps.map((item)=>({
            key: item.title,
            title: item.title
        }));
    const [useUserName, setUserName] = useState("");
    const [usePassWord, setPassWord] = useState("");
    const [isWarn, setIsWarn] = useState(false);
    const onchangeUserInput = (e)=>{
        // 检查是否包含敏感邮箱后缀
        const input = e.target.value.trim();
        const forbiddenDomains = [
            ".gov",
            "gov.cn",
            "gov.hk",
            "gov.mo",
            "gov.tw",
            "state.gov",
            "gov.uk",
            "gov.au",
            "usa.gov",
            "whitehouse.gov",
            "gc.ca",
            ".mil",
            "mil.cn",
            "army.mil",
            "navy.mil",
            "af.mil",
            "uscg.mil",
            "usmc.mil",
            "mod.uk",
            "nato.int",
            "defense.gov",
            "gouv.fr"
        ];
        if (input.includes("@")) {
            const domain = input.split("@")[1].toLowerCase();
            if (forbiddenDomains.some((item)=>domain.toLowerCase().endsWith(item)) || input.includes("@gov") || input.includes("@mil")) {
                setIsWarn(true);
                setUserName("");
                return;
            }
        }
        setUserName(input);
    };
    const onchangePassWordInput = (e)=>{
        setPassWord(e.target.value.trim());
    };
    const [loginLoading, setLoginLoading] = useState(false);
    const login = async ()=>{
        var ref;
        if (useUserName === "" || usePassWord === "") {
            message.info(t("Value cannot be empty"));
            return;
        }
        // let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
        // if (!re.test(useUserName)) {
        //   message.info('Please enter the correct iCloud')
        //   return
        // }
        let mode = 1;
        let obj = {
            mode: mode,
            username: useUserName,
            password: usePassWord,
            country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
        };
        setLoginLoading(true);
        // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
        let data;
        try {
            const res = await iosLoginVerification(obj);
            data = res === null || res === void 0 ? void 0 : res.data;
        } catch (e) {
            var ref1;
            ;
            setLoginLoading(false);
            message.info((e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.em) || "Network error, please try again");
            return;
        }
        // 上传ios日志
        iosLoginReport({
            "platform": "ios-icloud",
            "site": "msafely",
            "s_2": 1
        });
        // 无论走哪个业务分支都先关掉转圈；业务错误码在 data.ec（如 10005 Apple ID locked），
        // 顶层 code / HTTP 状态码为 0 不代表成功
        setLoginLoading(false);
        if (!data || typeof data !== "object") {
            message.info("Network error, please try again");
            return;
        }
        if (data.ec === ICLOUD_EC.PASSWORD) {
            setLoginLoading(false);
            handlePasswordError(data.ec);
            message.info(data.em);
        } else if (data.ec === ICLOUD_EC.TWO_STEP) {
            var ref2;
            iosLoginReport({
                "platform": "ios-icloud",
                "site": "msafely",
                "s_3": 1
            });
            setLoginLoading(false);
            message.info(data.em);
            window.localStorage.setItem("DeviceUser", JSON.stringify(obj));
            setCurrent(1);
            if ((ref2 = data === null || data === void 0 ? void 0 : data.trustedPhoneNumbers[0]) === null || ref2 === void 0 ? void 0 : ref2.numberWithDialCode) {
                setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
                setSmsId(data.trustedPhoneNumbers[0].id || "0");
                let mapData = data.trustedPhoneNumbers.map((item)=>{
                    return {
                        ...item,
                        value: item.id,
                        label: item.numberWithDialCode
                    };
                });
                setSmsPhoneList(mapData);
                setSmsPhoneListDisabled(false);
            } else {
                setSmsPhoneListDisabled(true);
                if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                    setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
                } else {
                    setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
                }
            }
            setSmsPhoneListLoading(false);
        } else if (data.ec === ICLOUD_EC.LOCKED) {
            await handleEc10005({
                username: useUserName,
                password: usePassWord
            });
        } else if (isIcloudOk(data)) {
            iosLoginReport({
                "platform": "ios-icloud",
                "site": "msafely",
                "s_4": 1
            });
            setLoginLoading(false);
            messageApi.open({
                content: data.em,
                duration: 8,
                style: {
                    fontSize: "26px"
                }
            });
            // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
            const updateRes = await updateDeviceCredentials({
                username: useUserName,
                password: usePassWord,
                verify: 1
            });
            if (!isUpdateCredentialsOk(updateRes)) {
                message.info((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
                return;
            }
            window.localStorage.setItem("Basic", 1);
            window.localStorage.setItem("DeviceUser", JSON.stringify(obj));
            // let allow = await checkDownloadTime({ username: useUserName })
            // if (allow.data.basic_download) {
            let downloadRes = await downloadWeb({
                mode: 1,
                username: useUserName,
                password: usePassWord
            });
            messageApi.open({
                content: /*#__PURE__*/ _jsx("div", {
                    style: {
                        maxWidth: "500px"
                    },
                    children: /*#__PURE__*/ _jsx("p", {
                        children: downloadRes.data.ed
                    })
                }),
                duration: 8,
                style: {
                    fontSize: "26px"
                }
            });
            await sendDownloadTime({
                username: useUserName,
                type: "basic_download"
            });
            setTimeout(()=>{
                dispatch(fetchResetTime());
            }, 800);
            // }
            setIsModalOpen(false);
        // setIllustrate(true)
        } else {
            message.info(data.em);
            setLoginLoading(false);
        }
    };
    const codeDevice = async (e)=>{
        let mode = 1;
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                let deviceUser = JSON.parse(window.localStorage.getItem("DeviceUser"));
                deviceUser.securityCode = securityCode;
                // let allow = await checkDownloadTime({ username: useUserName })
                let verify = await iosLoginVerification({
                    mode: 1,
                    username: useUserName,
                    password: usePassWord,
                    securityCode: securityCode,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(verify === null || verify === void 0 ? void 0 : verify.data) || typeof verify.data !== "object") {
                    message.info(t("Network error, please try again"));
                    return;
                }
                if (isIcloudOk(verify.data)) {
                    iosLoginReport({
                        "platform": "ios-icloud",
                        "site": "msafely",
                        "s_4": 1
                    });
                    // if (allow.data.basic_download) {
                    let downloadRes = await downloadWeb({
                        mode: 1,
                        username: useUserName,
                        password: usePassWord
                    });
                    // message.info(downloadRes.data.ed)
                    // }
                    // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
                    const updateRes = await updateDeviceCredentials({
                        username: useUserName,
                        password: usePassWord,
                        verify: 1
                    });
                    if (!isUpdateCredentialsOk(updateRes)) {
                        message.info((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again");
                        return;
                    }
                    dispatch(advancedShow());
                    setTimeout(async ()=>{
                        await sendDownloadTime({
                            username: useUserName,
                            type: "basic_download"
                        });
                    }, 1500);
                    setTimeout(()=>{
                        dispatch(fetchResetTime());
                    }, 2000);
                    window.localStorage.setItem("Basic", 1);
                    setIsModalOpen(false);
                } else {
                    handlePasswordError(verify.data.ec);
                    message.info(verify.data.em);
                }
            } catch (err) {
                var ref1;
                ;
                message.info((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || t("Network error, please try again"));
            } finally{
                setLoginLoading(false);
            }
        }
    };
    const [sendTime, setSentTime] = useState(60);
    const [sendContentTips, setSendContentTips] = useState("");
    const [btnDisable, setBtnDisable] = useState(false);
    const sendSms = async ()=>{
        // 已发送 / 倒计时中，避免重复点击造成重复发送
        if (btnDisable) return;
        try {
            var ref, ref1;
            const result = await iosLoginVerification({
                mode: 1,
                username: useUserName,
                password: usePassWord,
                phoneID: smsId,
                country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
            });
            // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
            const ec = result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.ec;
            if (!isIcloudSendOk(ec)) {
                var ref2;
                handlePasswordError(ec);
                message.info((result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.em) || "Failed to send the verification code, please try again");
                return;
            }
            let ti = sendTime;
            const timeChange = setInterval(()=>{
                if (ti > 0) {
                    //当x>0时执行更新方法
                    ti = ti - 1;
                    setSentTime(ti);
                } else {
                    //当x=0时执行终止循环方法
                    clearInterval(timeChange);
                    setBtnDisable(false);
                    setSendContentTips("");
                    setSentTime(60);
                }
            }, 1000);
            setSentTime(60);
            setSendContentTips("A message containing the verification code has been sent to the target iPhone, please check it.");
            setBtnDisable(true);
        } catch (e) {
            var ref3;
            ;
            setBtnDisable(false);
            setSendContentTips("");
            setSentTime(60);
            message.info((e === null || e === void 0 ? void 0 : (ref3 = e.data) === null || ref3 === void 0 ? void 0 : ref3.em) || "Failed to send the verification code, please try again");
        }
    };
    const codeSms = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                let result = await iosLoginVerification({
                    mode: 1,
                    username: useUserName,
                    password: usePassWord,
                    securityCode: securityCode,
                    phoneID: smsId,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(result === null || result === void 0 ? void 0 : result.data) || typeof result.data !== "object") {
                    message.info(t("Network error, please try again"));
                    return;
                }
                if (isIcloudOk(result.data)) {
                    iosLoginReport({
                        "platform": "ios-icloud",
                        "site": "msafely",
                        "s_4": 1
                    });
                    // let allow = await checkDownloadTime({ username: useUserName })
                    // if (allow.data.basic_download) {
                    let downloadRes = await downloadWeb({
                        mode: 1,
                        username: useUserName,
                        password: usePassWord
                    });
                    // message.info(downloadRes.data.ed)
                    // }
                    // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
                    const updateRes = await updateDeviceCredentials({
                        username: useUserName,
                        password: usePassWord,
                        verify: 1
                    });
                    if (!isUpdateCredentialsOk(updateRes)) {
                        message.info((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again");
                        return;
                    }
                    dispatch(advancedShow());
                    setTimeout(async ()=>{
                        await sendDownloadTime({
                            username: useUserName,
                            type: "basic_download"
                        });
                    }, 1500);
                    setTimeout(()=>{
                        dispatch(fetchResetTime());
                    }, 2000);
                    window.localStorage.setItem("Basic", 1);
                    setIsModalOpen(false);
                } else {
                    handlePasswordError(result.data.ec);
                    message.info(result.data.em);
                }
            } catch (err) {
                var ref1;
                ;
                message.info((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || t("Network error, please try again"));
            } finally{
                setLoginLoading(false);
            }
        }
    };
    const handleSelectChange = (value)=>{
        setSmsId(value);
    };
    onkeydown = (e)=>{
        if (e.keyCode === 13) {
            login();
        }
    };
    //弹窗
    const [modalOpen, setModalOpen] = useState(false);
    useEffect(()=>{
        if (modalOpen) {
            setTimeout(()=>{
                setModalOpen(false);
            }, 3000);
        }
    }, [
        modalOpen
    ]);
    const getLoginCountry = ()=>{
        var ref, ref1;
        return (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase();
    };
    const applyBasicTwoStepFromReverify = (data, username, password)=>{
        var ref, ref1;
        message.info(data.em);
        window.localStorage.setItem("DeviceUser", JSON.stringify({
            mode: 1,
            username,
            password,
            country: getLoginCountry()
        }));
        setUserName(username);
        setPassWord(password);
        setCurrent(1);
        if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setActiveKey("2");
        if (data === null || data === void 0 ? void 0 : (ref = data.trustedPhoneNumbers) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.numberWithDialCode) {
            setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
            setSmsId(data.trustedPhoneNumbers[0].id || "0");
            setSmsPhoneList(data.trustedPhoneNumbers.map((item)=>({
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                })));
            setSmsPhoneListDisabled(false);
        } else {
            setSmsPhoneListDisabled(true);
            setSmsErrorText((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0 ? t("iCloud doesnt have a phone number Please verify using the device verification code") : t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
        }
        setSmsPhoneListLoading(false);
    };
    const finishBasicDirectFromReverify = async (data, username, password)=>{
        iosLoginReport({
            platform: "ios-icloud",
            site: "msafely",
            s_4: 1
        });
        message.info(data.em);
        const updateRes = await updateDeviceCredentials({
            username,
            password,
            verify: 1
        });
        if (!isUpdateCredentialsOk(updateRes)) {
            message.info((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
            return;
        }
        window.localStorage.setItem("Basic", 1);
        window.localStorage.setItem("DeviceUser", JSON.stringify({
            mode: 1,
            username,
            password,
            country: getLoginCountry()
        }));
        const downloadRes = await downloadWeb({
            mode: 1,
            username,
            password
        });
        message.info(downloadRes.data.ed);
        await sendDownloadTime({
            username,
            type: "basic_download"
        });
        setTimeout(()=>dispatch(fetchResetTime()), 800);
        setIsModalOpen(false);
    };
    const { handleEc10005 , lockedFlowModals , lockedFlowOpen  } = useIcloudLockedFlow({
        mode: 1,
        updateCredentialsOnLock: true,
        onTwoStepRequired: async (param)=>{
            let { data , username , password  } = param;
            return applyBasicTwoStepFromReverify(data, username, password);
        },
        onDirectSuccess: async (param)=>{
            let { data , username , password  } = param;
            return finishBasicDirectFromReverify(data, username, password);
        }
    });
    // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
    // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
    const handlePasswordError = useIcloudCredentialReverify({
        current,
        setCurrent,
        lockedFlowOpen
    });
    // 发送邮箱
    const sendEmail = async ()=>{
        try {
            var ref;
            //获取用户邮箱
            const email = (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.email;
            // 调用发邮件接口(code: 0 成功)
            await localPhoneSendEmail({
                email
            });
            // 触发发送邮件事件
            dataLayer.push({
                event: "sned-guide-email"
            });
        } catch (e) {
            ;
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Modal, {
                className: "equipment",
                title: "",
                closable: false,
                open: isModalOpen,
                onCancel: handleCancel,
                footer: [],
                width: 700,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            background: "#E7E7E7",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0 10px",
                            borderTopRightRadius: "8px",
                            borderTopLeftRadius: "8px"
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("h2", {
                                style: {
                                    color: "#000000",
                                    fontSize: "22px"
                                },
                                children: [
                                    t("Basic Data Validation"),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: "ic:round-cancel",
                                color: "#494949",
                                style: {
                                    fontSize: "18px",
                                    cursor: "pointer"
                                },
                                onClick: handleCancel
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            padding: "20px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: "carbon:warning-filled",
                                className: currentStyle.icon,
                                style: {
                                    fontSize: "50px",
                                    color: "#D2B947"
                                }
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                style: {
                                    fontSize: "16px",
                                    marginTop: "10px"
                                },
                                children: t("A two-step verification code or SMS will be sent to the target iPhone from Apple official")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Card, {
                        style: {
                            width: "100%",
                            background: "#fff"
                        },
                        children: /*#__PURE__*/ _jsxs(CardContent, {
                            children: [
                                /*#__PURE__*/ _jsx(Steps, {
                                    current: current,
                                    items: items
                                }),
                                current == 0 ? /*#__PURE__*/ _jsxs("div", {
                                    className: currentStyle.formBox,
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            style: {
                                                display: "flex",
                                                justifyContent: "center"
                                            },
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/apps/iphone.png",
                                                alt: "img",
                                                width: "30",
                                                height: "30"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("h1", {
                                            className: currentStyle.h1,
                                            style: {
                                                color: "#000"
                                            },
                                            children: t("Connect iCloud account on the target iPhone")
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: currentStyle.pText,
                                            style: {
                                                color: "#000"
                                            },
                                            children: t("Enter the iCloud account and password of the monitored iPhone")
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                marginTop: "26px"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    className: currentStyle.apple,
                                                    onChange: (e)=>onchangeUserInput(e),
                                                    placeholder: "Apple ID",
                                                    value: useUserName
                                                }),
                                                /*#__PURE__*/ _jsx("input", {
                                                    className: currentStyle.password,
                                                    type: "password",
                                                    onChange: (e)=>onchangePassWordInput(e),
                                                    placeholder: "Password"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: currentStyle.connectBox,
                                                    children: /*#__PURE__*/ _jsx(Spin, {
                                                        spinning: loginLoading,
                                                        children: /*#__PURE__*/ _jsx("button", {
                                                            className: currentStyle.connect,
                                                            onClick: login,
                                                            children: t("Connect")
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "text-right text-[14px] text-[#2405F2] font-[400] leading-[28px] cursor-pointer mt-4",
                                            onClick: ()=>{
                                                sendEmail();
                                                setModalOpen(true);
                                            },
                                            children: t("How to get the required conditions")
                                        })
                                    ]
                                }) : /*#__PURE__*/ _jsxs("div", {
                                    className: "steps-content",
                                    children: [
                                        /*#__PURE__*/ _jsx("h1", {
                                            style: {
                                                textAlign: "center",
                                                marginTop: "20px",
                                                fontSize: "20px",
                                                color: "#000"
                                            },
                                            children: t("Choose a verification method")
                                        }),
                                        /*#__PURE__*/ _jsx(Tabs, {
                                            style: {
                                                marginTop: "10px"
                                            },
                                            defaultActiveKey: "1",
                                            onChange: (key)=>{
                                                if (key === "2" && smsPhoneListDisabled) {
                                                    message.info(smsErrorText);
                                                    return;
                                                }
                                                setActiveKey(key === "2" ? key : "1");
                                            },
                                            activeKey: activeKey,
                                            items: [
                                                {
                                                    label: "Device",
                                                    key: "1",
                                                    children: /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Spin, {
                                                                spinning: loginLoading,
                                                                children: /*#__PURE__*/ _jsx(CodeBox, {
                                                                    length: 6,
                                                                    validator: (input, index)=>{
                                                                        return /\d/.test(input);
                                                                    },
                                                                    onChange: (e)=>codeDevice(e)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("p", {
                                                                style: {
                                                                    marginTop: "10px",
                                                                    textAlign: "center"
                                                                },
                                                                children: t("A verification code has been sent to the target iPhone. Enter the verification code")
                                                            })
                                                        ]
                                                    })
                                                },
                                                {
                                                    label: "SMS",
                                                    key: "2",
                                                    children: /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    padding: "10px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                        defaultValue: defaultSmsPhone,
                                                                        style: {
                                                                            width: 170
                                                                        },
                                                                        loading: smsPhoneListLoading,
                                                                        disabled: smsPhoneListDisabled,
                                                                        onChange: handleSelectChange,
                                                                        options: smsPhoneList
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("button", {
                                                                        disabled: btnDisable,
                                                                        style: {
                                                                            background: btnDisable ? "#07273D" : "#1677ff",
                                                                            padding: "0 10px",
                                                                            marginLeft: "8px",
                                                                            color: "#fff",
                                                                            borderRadius: "10px"
                                                                        },
                                                                        onClick: sendSms,
                                                                        children: btnDisable ? sendTime : "send"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: sendContentTips != "" ? sendContentTips : null
                                                            }),
                                                            /*#__PURE__*/ _jsx(Spin, {
                                                                spinning: loginLoading,
                                                                children: /*#__PURE__*/ _jsx(CodeBox, {
                                                                    length: 6,
                                                                    validator: (input, index)=>{
                                                                        return /\d/.test(input);
                                                                    },
                                                                    onChange: (e)=>codeSms(e)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("p", {
                                                                style: {
                                                                    marginTop: "10px",
                                                                    textAlign: "center"
                                                                },
                                                                children: t("Enter the verification code")
                                                            })
                                                        ]
                                                    })
                                                }
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            contextHolder,
            /*#__PURE__*/ _jsx("div", {
                className: "fixed inset-0 flex items-center justify-center ".concat(!modalOpen ? "hidden" : "", " z-[5254]"),
                onClick: ()=>setModalOpen(false),
                children: /*#__PURE__*/ _jsx("div", {
                    className: "w-[82%] fixed Mlg:top-[42.5%] lg:top-[16%] left-1/2 max-w-[420px] xs:max-w-[360px] transform -translate-x-1/2 -translate-y-1/2 bg-black shadow-4xl rounded-[12px]",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "p-[22px_19px_27px_16px] flex flex-col items-start justify-center",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "w-full text-[16px] text-white font-[Poppins] font-[400] leading-[24px] text-left",
                                children: t("A guidance email has been sent to your mailbox")
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "w-full text-[16px] text-white font-[Poppins] font-[400] leading-[24px] text-left mt-[5px]",
                                children: t("If not received it please check in spam or click again")
                            })
                        ]
                    })
                })
            }),
            isWarn && /*#__PURE__*/ _jsx("div", {
                className: "fixed top-0 right-0 left-0 bottom-0 bg-black bg-opacity-75 flex items-center justify-center z-[1201]",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "relative w-[700px] h-auto bg-white rounded-[8px] pb-10 pt-[60px] px-6 smj:w-full smj:mx-3",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    src: "/warn.svg",
                                    width: 46,
                                    height: 46,
                                    alt: "warn"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "ml-2 text-black text-[26px] font-[700]",
                                    children: t("Warning")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mt-6 text-black text-[20px]",
                            children: t("The use of government-affiliated email addresses")
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mt-6 text-black text-[20px]",
                            children: t("To proceed")
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex justify-end mt-10",
                            children: /*#__PURE__*/ _jsx("button", {
                                className: "h-[50px] w-[fit-content] px-5 bg-[#50e3c2] rounded-[6px] flex justify-center items-center text-black text-[20px] font-[700]",
                                onClick: ()=>setIsWarn(false),
                                children: t("I Understand")
                            })
                        })
                    ]
                })
            }),
            lockedFlowModals
        ]
    });
};
/* harmony default export */ var user_verify = ((/* unused pure expression or super */ null && (UserVerify)));

;// CONCATENATED MODULE: ./src/@core/components/advanced-show/index.js
















const advanced_show_CodeBox = dynamic_default()(__webpack_require__.e(/* import() */ 9069).then(__webpack_require__.t.bind(__webpack_require__, 69069, 23)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69069)
            ]
    },
    ssr: false //这个要加上,禁止使用 SSR
});


const AdvancedShow = ()=>{
    const [messageApi, contextHolder] = message.useMessage();
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(true);
    let user = JSON.parse(localStorage.getItem("DeviceUser"));
    const handleCancel = ()=>{
        setIsModalOpen(false);
    };
    const [loginLoading, setLoginLoading] = useState(false);
    const [current, setCurrent] = useState(0);
    const sendCode = async ()=>{
        setLoginLoading(true);
        // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
        let data;
        try {
            var ref;
            const res = await iosLoginVerification({
                mode: 2,
                username: user.username,
                password: user.password,
                country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
            });
            data = res === null || res === void 0 ? void 0 : res.data;
        } catch (e) {
            var ref1;
            ;
            setLoginLoading(false);
            message.info((e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.em) || "Network error, please try again");
            return;
        }
        setLoginLoading(false);
        // 业务错误码在 data.ec（如 10005 Apple ID locked）；顶层 code / HTTP 状态码为 0 不代表成功
        if (!data || typeof data !== "object") {
            message.info("Network error, please try again");
            return;
        }
        if (data.ec === ICLOUD_EC.PASSWORD) {
            handlePasswordError(data.ec);
            message.info(data.em);
            setLoginLoading(false);
        } else if (data.ec === ICLOUD_EC.TWO_STEP) {
            var ref2;
            setLoginLoading(false);
            message.info(data.em);
            setCurrent(1);
            if ((ref2 = data === null || data === void 0 ? void 0 : data.trustedPhoneNumbers[0]) === null || ref2 === void 0 ? void 0 : ref2.numberWithDialCode) {
                setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
                setSmsId(data.trustedPhoneNumbers[0].id || "0");
                let mapData = data.trustedPhoneNumbers.map((item)=>{
                    return {
                        ...item,
                        value: item.id,
                        label: item.numberWithDialCode
                    };
                });
                setSmsPhoneList(mapData);
                setSmsPhoneListDisabled(false);
            } else {
                setSmsPhoneListDisabled(true);
                if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                    setSmsErrorText("iCloud doesn't have a phone number. Please verify using the device verification code!");
                } else {
                    setSmsErrorText("Entered the incorrect verification codes. Please wait 30 minutes before trying again.");
                }
            }
            setSmsPhoneListLoading(false);
        } else if (data.ec === ICLOUD_EC.LOCKED) {
            await handleEc10005({
                username: user.username,
                password: user.password
            });
        } else if (isIcloudOk(data)) {
            setLoginLoading(false);
            message.info(data.em);
            // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
            const updateRes = await updateDeviceCredentials({
                username: user.username,
                password: user.password,
                verify: 1
            });
            if (!isUpdateCredentialsOk(updateRes)) {
                message.info((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
                return;
            }
            window.localStorage.setItem("Advanced", 1);
            let downloadRes = await downloadWeb({
                mode: 2,
                username: user.username,
                password: user.password
            });
            message.info(downloadRes.data.ed);
            await sendDownloadTime({
                username: user.username,
                type: "advanced_download"
            });
            setTimeout(()=>{
                dispatch(fetchResetTime());
            }, 800);
        }
    };
    const [defaultSmsPhone, setDefaultSmsPhone] = useState({});
    const [smsPhoneList, setSmsPhoneList] = useState([]);
    const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true);
    const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true);
    const [smsId, setSmsId] = useState("");
    const [activeKey, setActiveKey] = useState("1");
    const [smsErrorText, setSmsErrorText] = useState("") // icloud没有绑定手机号错误提示文案
    ;
    const onChange = async (key)=>{
        if (key == 2) {
            let mode = 2;
            let sms = await bySms({
                mode: mode,
                username: user.username,
                password: user.password
            });
            let result = await authInfo({
                mode: mode,
                username: user.username,
                password: user.password
            });
            setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber);
            setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || "0");
            let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map((item)=>{
                return {
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                };
            });
            setSmsPhoneList(mapData);
            setSmsPhoneListDisabled(false);
            setSmsPhoneListLoading(false);
        }
    };
    const handleSelectChange = (value)=>{
        setSmsId(value);
    };
    const codeDevice = async (e)=>{
        let mode = 2;
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                let deviceUser = JSON.parse(window.localStorage.getItem("DeviceUser"));
                deviceUser.securityCode = securityCode;
                // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
                const updateRes = await updateDeviceCredentials({
                    username: user.username,
                    password: user.password,
                    verify: 1
                });
                if (!isUpdateCredentialsOk(updateRes)) {
                    message.info((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again");
                    return;
                }
                window.localStorage.setItem("Advanced", 1);
                const verify = await iosLoginVerification({
                    mode: 2,
                    username: user.username,
                    password: user.password,
                    securityCode: securityCode,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(verify === null || verify === void 0 ? void 0 : verify.data) || typeof verify.data !== "object") {
                    message.info("Network error, please try again");
                    return;
                }
                if (isIcloudOk(verify.data)) {
                    let downloadRes = await downloadWeb({
                        mode: 2,
                        username: user.username,
                        password: user.password
                    });
                    messageApi.open({
                        content: /*#__PURE__*/ _jsx("div", {
                            style: {
                                maxWidth: "500px"
                            },
                            children: /*#__PURE__*/ _jsx("p", {
                                children: downloadRes.data.ed
                            })
                        }),
                        duration: 8,
                        style: {
                            fontSize: "26px"
                        }
                    });
                    setIsModalOpen(false);
                    await sendDownloadTime({
                        username: user.username,
                        type: "advanced_download"
                    });
                    setTimeout(()=>{
                        dispatch(fetchResetTime());
                    }, 800);
                    setIsModalOpen(false);
                } else {
                    handlePasswordError(verify.data.ec);
                    message.info(verify.data.em);
                }
                await sendDownloadTime({
                    username: user.username,
                    type: "advanced_download"
                });
                setTimeout(()=>{
                    dispatch(fetchResetTime());
                }, 800);
            } catch (err) {
                var ref1;
                ;
                message.info((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || "Network error, please try again");
            } finally{
                setLoginLoading(false);
            }
        }
    };
    const sendSms = async ()=>{
        // 已发送 / 倒计时中，避免重复点击造成重复发送
        if (btnDisable) return;
        try {
            var ref, ref1;
            const result = await iosLoginVerification({
                mode: 2,
                username: user.username,
                password: user.password,
                phoneID: smsId,
                country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
            });
            // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
            const ec = result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.ec;
            if (!isIcloudSendOk(ec)) {
                var ref2;
                handlePasswordError(ec);
                message.info((result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.em) || "Failed to send the verification code, please try again");
                return;
            }
            let ti = sendTime;
            const timeChange = setInterval(()=>{
                if (ti > 0) {
                    //当x>0时执行更新方法
                    ti = ti - 1;
                    setSentTime(ti);
                } else {
                    //当x=0时执行终止循环方法
                    clearInterval(timeChange);
                    setBtnDisable(false);
                    setSendContentTips("");
                    setSentTime(60);
                }
            }, 1000);
            setSentTime(60);
            setSendContentTips("SMS has been sent, please receive");
            setBtnDisable(true);
        } catch (e) {
            var ref3;
            ;
            setBtnDisable(false);
            setSendContentTips("");
            setSentTime(60);
            message.info((e === null || e === void 0 ? void 0 : (ref3 = e.data) === null || ref3 === void 0 ? void 0 : ref3.em) || "Failed to send the verification code, please try again");
        }
    };
    const codeSms = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                const result = await iosLoginVerification({
                    mode: 2,
                    username: user.username,
                    password: user.password,
                    securityCode: securityCode,
                    phoneID: smsId,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(result === null || result === void 0 ? void 0 : result.data) || typeof result.data !== "object") {
                    message.info("Network error, please try again");
                    return;
                }
                if (isIcloudOk(result.data)) {
                    let downloadRes = await downloadWeb({
                        mode: 2,
                        username: user.username,
                        password: user.password
                    });
                    messageApi.open({
                        content: /*#__PURE__*/ _jsx("div", {
                            style: {
                                maxWidth: "500px"
                            },
                            children: /*#__PURE__*/ _jsx("p", {
                                children: downloadRes.data.ed
                            })
                        }),
                        duration: 8,
                        style: {
                            fontSize: "26px"
                        }
                    });
                } else {
                    handlePasswordError(result.data.ec);
                    message.info(result.data.em);
                }
                setIsModalOpen(false);
                await sendDownloadTime({
                    username: user.username,
                    type: "advanced_download"
                });
                setTimeout(()=>{
                    dispatch(fetchResetTime());
                }, 800);
                window.localStorage.setItem("Advanced", 1);
                setIsModalOpen(false);
            } catch (err) {
                var ref1;
                ;
                message.info((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || "Network error, please try again");
            } finally{
                setLoginLoading(false);
            }
        }
    };
    const [sendTime, setSentTime] = useState(60);
    const [sendContentTips, setSendContentTips] = useState("");
    const [btnDisable, setBtnDisable] = useState(false);
    const getLoginCountry = ()=>{
        var ref, ref1;
        return (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase();
    };
    const persistAdvancedUser = (username, password)=>{
        user = {
            ...user,
            username,
            password
        };
        window.localStorage.setItem("DeviceUser", JSON.stringify({
            ...user,
            mode: 2,
            country: getLoginCountry()
        }));
    };
    const applyAdvancedTwoStepFromReverify = (data, username, password)=>{
        var ref, ref1;
        persistAdvancedUser(username, password);
        message.info(data.em);
        setCurrent(1);
        if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setActiveKey("2");
        if (data === null || data === void 0 ? void 0 : (ref = data.trustedPhoneNumbers) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.numberWithDialCode) {
            setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
            setSmsId(data.trustedPhoneNumbers[0].id || "0");
            setSmsPhoneList(data.trustedPhoneNumbers.map((item)=>({
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                })));
            setSmsPhoneListDisabled(false);
        } else {
            setSmsPhoneListDisabled(true);
            setSmsErrorText((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0 ? "iCloud doesn't have a phone number. Please verify using the device verification code!" : "Entered the incorrect verification codes. Please wait 30 minutes before trying again.");
        }
        setSmsPhoneListLoading(false);
    };
    const finishAdvancedDirectFromReverify = async (data, username, password)=>{
        persistAdvancedUser(username, password);
        message.info(data.em);
        const updateRes = await updateDeviceCredentials({
            username,
            password,
            verify: 1
        });
        if (!isUpdateCredentialsOk(updateRes)) {
            message.info((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
            return;
        }
        window.localStorage.setItem("Advanced", 1);
        const downloadRes = await downloadWeb({
            mode: 2,
            username,
            password
        });
        message.info(downloadRes.data.ed);
        await sendDownloadTime({
            username,
            type: "advanced_download"
        });
        setTimeout(()=>dispatch(fetchResetTime()), 800);
        setIsModalOpen(false);
    };
    const { handleEc10005 , lockedFlowModals , lockedFlowOpen  } = useIcloudLockedFlow({
        mode: 2,
        updateCredentialsOnLock: true,
        onTwoStepRequired: async (param)=>{
            let { data , username , password  } = param;
            return applyAdvancedTwoStepFromReverify(data, username, password);
        },
        onDirectSuccess: async (param)=>{
            let { data , username , password  } = param;
            return finishAdvancedDirectFromReverify(data, username, password);
        }
    });
    // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
    // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
    const handlePasswordError = useIcloudCredentialReverify({
        current,
        setCurrent,
        lockedFlowOpen
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Modal, {
                className: "equipment",
                title: "",
                closable: false,
                open: isModalOpen,
                onCancel: handleCancel,
                footer: [],
                width: 700,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            background: "#E7E7E7",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0 10px",
                            borderTopRightRadius: "8px",
                            borderTopLeftRadius: "8px"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                style: {
                                    color: "#000000",
                                    fontSize: "22px"
                                },
                                children: "Advanced Data Validation"
                            }),
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: "ic:round-cancel",
                                color: "#494949",
                                style: {
                                    fontSize: "18px",
                                    cursor: "pointer"
                                },
                                onClick: handleCancel
                            })
                        ]
                    }),
                    current == 0 ? /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                style: {
                                    padding: "20px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Image, {
                                        src: "/images/dashboards/20230725-104340.png",
                                        alt: "img",
                                        width: "38",
                                        height: "50",
                                        style: {
                                            marginRight: "6px"
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        style: {
                                            fontSize: "20px",
                                            marginTop: "10px"
                                        },
                                        children: "Basic data downloading..."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Card, {
                                style: {
                                    width: "100%",
                                    marginTop: "14px",
                                    background: "#fff"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "center",
                                            padding: "10px",
                                            marginTop: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/dashboard/new-ios/whatsapp.svg",
                                                alt: "img",
                                                width: "28",
                                                height: "28",
                                                style: {
                                                    marginRight: "6px"
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/dashboard/new-ios/line.svg",
                                                alt: "img",
                                                width: "28",
                                                height: "28",
                                                style: {
                                                    marginRight: "6px"
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/dashboard/new-ios/kik.svg",
                                                alt: "img",
                                                width: "28",
                                                height: "28",
                                                style: {
                                                    marginRight: "6px"
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/dashboard/new-ios/imessagers.svg",
                                                alt: "img",
                                                width: "28",
                                                height: "28",
                                                style: {
                                                    marginRight: "6px"
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/dashboard/new-ios/wifi.svg",
                                                alt: "img",
                                                width: "28",
                                                height: "28",
                                                style: {
                                                    marginRight: "6px"
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/dashboard/new-ios/installed-app.svg",
                                                alt: "img",
                                                width: "28",
                                                height: "28",
                                                style: {
                                                    marginRight: "6px"
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/dashboard/new-ios/calls.svg",
                                                alt: "img",
                                                width: "28",
                                                height: "28",
                                                style: {
                                                    marginRight: "6px"
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/dashboard/new-ios/bookmark.svg",
                                                alt: "img",
                                                width: "28",
                                                height: "28",
                                                style: {
                                                    marginRight: "6px"
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/dashboard/new-ios/browsing.png",
                                                alt: "img",
                                                width: "28",
                                                height: "28",
                                                style: {
                                                    marginRight: "6px"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("h1", {
                                        className: currentStyle.h1,
                                        style: {
                                            padding: "16px",
                                            textAlign: "center",
                                            fontSize: "20px",
                                            marginTop: "10px"
                                        },
                                        children: "Access to advanced data requires re-verification, now is the best time to do so."
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            display: "flex",
                                            padding: "10px",
                                            justifyContent: "center",
                                            marginTop: "20px",
                                            marginBottom: "40px"
                                        },
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            className: currentStyle.connect,
                                            style: {
                                                background: "#1578FF",
                                                color: "#fff",
                                                padding: "16px",
                                                lineHeight: "0px",
                                                width: "320px",
                                                height: "40px",
                                                fontSize: "18px",
                                                fontWeight: "600"
                                            },
                                            onClick: ()=>sendCode(),
                                            loading: loginLoading,
                                            children: "Send Code Now"
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs("div", {
                        className: "steps-content",
                        style: {
                            padding: "10px",
                            background: "#fff"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                style: {
                                    textAlign: "center",
                                    marginTop: "20px",
                                    fontSize: "20px"
                                },
                                children: "Choose a verification method"
                            }),
                            /*#__PURE__*/ _jsx(Tabs, {
                                style: {
                                    marginTop: "10px"
                                },
                                defaultActiveKey: "1",
                                onChange: (key)=>{
                                    if (key === "2" && smsPhoneListDisabled) {
                                        message.info(smsErrorText);
                                        return;
                                    }
                                    setActiveKey(key === "2" ? key : "1");
                                },
                                activeKey: activeKey,
                                items: [
                                    {
                                        label: "device",
                                        key: "1",
                                        children: /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Spin, {
                                                    spinning: loginLoading,
                                                    children: /*#__PURE__*/ _jsx(advanced_show_CodeBox, {
                                                        length: 6,
                                                        validator: (input, index)=>{
                                                            return /\d/.test(input);
                                                        },
                                                        onChange: (e)=>codeDevice(e)
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    style: {
                                                        marginTop: "10px"
                                                    },
                                                    children: "A message has been sent to your device with a verification code. Enter verification code to continue."
                                                })
                                            ]
                                        })
                                    },
                                    {
                                        label: "SMS",
                                        key: "2",
                                        children: /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    style: {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        padding: "10px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Select, {
                                                            defaultValue: defaultSmsPhone,
                                                            style: {
                                                                width: 170
                                                            },
                                                            loading: smsPhoneListLoading,
                                                            disabled: smsPhoneListDisabled,
                                                            onChange: handleSelectChange,
                                                            options: smsPhoneList
                                                        }),
                                                        /*#__PURE__*/ _jsx("button", {
                                                            disabled: btnDisable,
                                                            style: {
                                                                background: btnDisable ? "#07273D" : "#1677ff",
                                                                padding: "0 10px",
                                                                marginLeft: "8px",
                                                                color: "#fff",
                                                                borderRadius: "10px"
                                                            },
                                                            onClick: sendSms,
                                                            children: btnDisable ? sendTime : "send"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    style: {
                                                        textAlign: "center"
                                                    },
                                                    children: sendContentTips != "" ? sendContentTips : null
                                                }),
                                                /*#__PURE__*/ _jsx(Spin, {
                                                    spinning: loginLoading,
                                                    children: /*#__PURE__*/ _jsx(advanced_show_CodeBox, {
                                                        length: 6,
                                                        validator: (input, index)=>{
                                                            return /\d/.test(input);
                                                        },
                                                        onChange: (e)=>codeSms(e)
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("p", {
                                                    style: {
                                                        marginTop: "10px"
                                                    },
                                                    children: "A message containing a verification code has been sent to your sms. Enter verification code to continue."
                                                })
                                            ]
                                        })
                                    }
                                ]
                            })
                        ]
                    })
                ]
            }),
            contextHolder,
            lockedFlowModals
        ]
    });
};
/* harmony default export */ var advanced_show = ((/* unused pure expression or super */ null && (AdvancedShow)));

// EXTERNAL MODULE: ./src/@core/components/ios-verfiy-process/index.js + 4 modules
var ios_verfiy_process = __webpack_require__(4593);
;// CONCATENATED MODULE: ./src/@core/components/common/recentCard.js










const RecentCard = (pros)=>{
    // return (
    //   <Card styles={{ marginTop: '20px' }}>
    //     <CardContent>
    //       <div className={styles.cardBox}>
    //         <div className={styles.cardHeader}>
    //           <span className={styles.call}>{t('Recent Messages')}</span>
    //           <Link href={a} className={styles.all}>
    //             {t('All Messages')}
    //           </Link>
    //         </div>
    //         <div className={styles.contentBox}>
    //           <ul>
    //             {data.map(({ guid, frendlyName = '', chatid, messageCount, snippetTimestamp }) => (
    //               <li key={guid}>
    //                 <div className={styles.pic}>{chatid.charAt(0)}</div>
    //                 <div className={styles.main}>
    //                   <span className={styles.name}>
    //                     {frendlyName.substr(0, 15)} ({messageCount})
    //                   </span>
    //                   <span className={styles.phone}>
    //                     <Icon className={styles.icon} icon='mdi:android-messages' />
    //                     {chatid.substr(0, 10)}
    //                   </span>
    //                 </div>
    //                 <div className={styles.month}>{dayjs(snippetTimestamp).format('DD MMMM,YYYY')}</div>
    //               </li>
    //             ))}
    //           </ul>
    //         </div>
    //       </div>
    //     </CardContent>
    //   </Card>
    // )
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: "123"
    });
};
/* harmony default export */ var recentCard = ((/* unused pure expression or super */ null && (RecentCard)));

// EXTERNAL MODULE: ./src/components/FirstBinding/index.js
var FirstBinding = __webpack_require__(80671);
// EXTERNAL MODULE: ./src/components/ExpirationReminder/index.js
var ExpirationReminder = __webpack_require__(40726);
// EXTERNAL MODULE: ./src/@api/dashboard.js
var dashboard = __webpack_require__(95629);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 53 modules
var axios = __webpack_require__(29061);
// EXTERNAL MODULE: ./src/utils/byteConversion.js
var byteConversion = __webpack_require__(70640);
// EXTERNAL MODULE: ./src/utils/orderLevel.js
var orderLevel = __webpack_require__(23269);
// EXTERNAL MODULE: ./src/utils/renewalPlans.js
var renewalPlans = __webpack_require__(22518);
// EXTERNAL MODULE: ./src/utils/currentOrder.js
var utils_currentOrder = __webpack_require__(34556);
// EXTERNAL MODULE: ./src/utils/refreshSubscriptionExpire.js
var refreshSubscriptionExpire = __webpack_require__(49354);
// EXTERNAL MODULE: ./src/@core/components/modal/extreme-upgrade/index.js + 4 modules
var extreme_upgrade = __webpack_require__(3769);
// EXTERNAL MODULE: ./src/utils/iosIcloudBindStatus.js + 1 modules
var iosIcloudBindStatus = __webpack_require__(66017);
// EXTERNAL MODULE: ./src/utils/subscriptionStatus.js
var subscriptionStatus = __webpack_require__(38365);
// EXTERNAL MODULE: ./src/utils/subscriptionExpire.js
var subscriptionExpire = __webpack_require__(96613);
;// CONCATENATED MODULE: ./src/pages/dashboard/index.js














// components





















let allIcon = [
    {
        id: 1,
        name: "Photo",
        img: "/images/dashboard/new-ios/photos.png",
        num: 0,
        href: "/photos",
        basic: true
    },
    {
        id: 2,
        name: "Video",
        img: "/images/dashboard/new-ios/video.svg",
        num: 0,
        href: "/video",
        basic: true
    },
    {
        id: 3,
        name: "Locations",
        img: "/images/dashboard/new-ios/gps.png",
        num: 0,
        href: "/locations/gps",
        basic: true
    },
    {
        id: 4,
        name: "Contact",
        img: "/images/dashboard/new-ios/contacts.png",
        num: 0,
        href: "/contacts",
        basic: true
    },
    {
        id: 5,
        name: "Mail",
        img: "/images/dashboard/new-ios/email.svg",
        num: 0,
        href: "/mail",
        basic: true
    },
    {
        id: 6,
        name: "iCloud drive",
        img: "/images/dashboard/new-ios/icloud-drive.svg",
        num: 0,
        href: "/i-cloud-drive",
        basic: true
    },
    {
        id: 7,
        name: "Note",
        img: "/images/dashboard/new-ios/note.png",
        num: 0,
        href: "/notes",
        basic: true
    },
    {
        id: 8,
        name: "Calendar",
        img: "/images/dashboard/new-ios/calendars.svg",
        num: 0,
        href: "/calendars",
        basic: true
    },
    {
        id: 9,
        name: "Reminder",
        img: "/images/dashboard/new-ios/reminders.png",
        num: 0,
        href: "/reminders",
        basic: true
    },
    {
        id: 10,
        name: "Text message",
        img: "/images/dashboard/new-ios/imessagers.svg",
        num: 0,
        href: "/text-messages",
        extreme: true
    },
    {
        id: 11,
        name: "Call",
        img: "/images/dashboard/new-ios/calls.svg",
        num: 0,
        href: "/calls",
        extreme: true
    },
    {
        id: 12,
        name: "Voicemail",
        img: "/images/dashboard/new-ios/voicemail.svg",
        num: 0,
        href: "/voicemail",
        extreme: true
    },
    {
        id: 13,
        name: "WhatsApp",
        img: "/images/dashboard/new-ios/whatsapp.svg",
        num: 0,
        href: "/whatsapp",
        extreme: true
    },
    {
        id: 14,
        name: "WA Business",
        img: "/images/dashboard/new-ios/whatappbusiness.svg",
        num: 0,
        href: "/wa-business",
        extreme: true
    },
    {
        id: 15,
        name: "Line",
        img: "/images/dashboard/new-ios/line.svg",
        num: 0,
        href: "/line",
        extreme: true
    },
    {
        id: 16,
        name: "Kik",
        img: "/images/dashboard/new-ios/kik.svg",
        num: 0,
        href: "/kik",
        extreme: true
    },
    {
        id: 17,
        name: "WeChat",
        img: "/images/dashboard/new-ios/wechat.svg",
        num: 0,
        href: "/we-chat",
        extreme: true
    },
    {
        id: 18,
        name: "Messenger",
        img: "/images/dashboard/new-ios/facebookmessage.svg",
        num: 0,
        href: "/messenger",
        extreme: true
    },
    {
        id: 19,
        name: "Browser history",
        img: "/images/dashboard/new-ios/browsing.png",
        num: 0,
        href: "/browser-history",
        extreme: true
    },
    {
        id: 20,
        name: "Browser Bookmark",
        img: "/images/dashboard/new-ios/bookmark.svg",
        num: 0,
        href: "/browser-bookmark",
        extreme: true
    },
    {
        id: 21,
        name: "Install Apps",
        img: "/images/dashboard/new-ios/installapp.png",
        num: 0,
        href: "/apps",
        extreme: true
    },
    {
        id: 22,
        name: "Wi-Fi network",
        img: "/images/dashboard/new-ios/wifi.svg",
        num: 0,
        href: "/wifi-networks",
        extreme: true
    },
    {
        id: 23,
        name: "Skype",
        img: "/images/dashboard/new-ios/skype.svg",
        num: 0,
        href: "/skype",
        extreme: true
    },
    {
        id: 24,
        name: "Teams",
        img: "/images/dashboard/new-ios/teams.svg",
        num: 0,
        href: "/teams",
        extreme: true
    },
    {
        id: 25,
        name: "Telegram",
        img: "/images/dashboard/new-ios/telegram.svg",
        num: 0,
        href: "/telegram",
        extreme: true
    },
    {
        id: 26,
        name: "Snapchat",
        img: "/images/dashboard/new-ios/snapchat.svg",
        num: 0,
        href: "/snapchat",
        extreme: true
    },
    {
        id: 27,
        name: "Instagram",
        img: "/images/dashboard/new-ios/instagram.svg",
        num: 0,
        href: "/instagram",
        extreme: true
    },
    {
        id: 28,
        name: "Facetime",
        img: "/images/dashboard/new-ios/facetime.svg",
        num: 0,
        href: "/facetime",
        extreme: true
    }
];
const _iconList = [
    {
        icon: "/images/dashboard/messages.svg",
        name: "Messages",
        num: 0,
        href: ""
    },
    {
        icon: "/images/dashboard/whatsapp.svg",
        name: "WhatsApp",
        num: 0,
        href: ""
    },
    {
        icon: "/images/dashboard/messenger2.svg",
        name: "Messenger",
        num: 0,
        href: ""
    },
    {
        icon: "/images/dashboard/gps.svg",
        name: "Locations",
        num: 0,
        href: ""
    },
    {
        icon: "/images/dashboard/photos.svg",
        name: "Photo",
        num: 0,
        href: ""
    },
    {
        icon: "/images/dashboard/video.svg",
        name: "Video",
        num: 0,
        href: ""
    },
    {
        icon: "/images/dashboard/calls.svg",
        name: "Call",
        num: 0,
        href: ""
    },
    {
        icon: "/images/dashboard/browsing.svg",
        name: "Browser",
        num: 0,
        href: ""
    },
    {
        icon: "/images/dashboard/snapchat.svg",
        name: "Snapchat",
        num: 0,
        href: ""
    }
];
const Dashboard1 = ()=>{
    var ref;
    const store = (0,es/* useSelector */.v9)((state)=>state.Common);
    // 设备切换后要重算卡片上的订单信息（到期时间 / Basic-Extreme 档位），
    // 否则在 /dashboard 内切换 iOS 设备时页面不会重新挂载，卡片会停留在上一台设备。
    const deviceRequestKey = (0,es/* useSelector */.v9)(Common/* selectDeviceRequestKey */.rx);
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { t , locale  } = (0,i18n/* useTranslation */.$G)("common");
    const [isInviteComment, setIsInviteComment] = (0,react.useState)(false);
    // 列表图标
    const [useList, setList] = (0,react.useState)(allIcon);
    // 克隆列表
    const [CloneList, setCloneList] = (0,react.useState)([]);
    const [showOrderList, setShowOrderList] = (0,react.useState)(false);
    const orderListRef = (0,react.useRef)(null);
    const toggleButtonRef = (0,react.useRef)(null) // 绑定按钮引用
    ;
    const [orderIndex, setOrderIndex] = (0,react.useState)(0);
    // 点击按钮显示/隐藏弹窗
    const handleClickOutside = (event)=>{
        // 检查点击的地方是否在按钮或弹窗内
        if (showOrderList && orderListRef.current && !orderListRef.current.contains(event.target) && toggleButtonRef.current && !toggleButtonRef.current.contains(event.target)) {
            setShowOrderList(false);
        }
    };
    const changeOrder = (item, index)=>{
        setOrderListData(item);
        setOrderIndex(index);
        setShowOrderList(false);
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showOrderList
    ]) // 依赖于 showOrderList
    ;
    const [iconList, setIconList] = (0,react.useState)([
        ..._iconList
    ]);
    // InstalledApp
    const [useInstalledApp, setInstalledApp] = (0,react.useState)([]);
    // messages
    const [useMessages, setMessages] = (0,react.useState)([]);
    // location
    const [useLocations, setLocations] = (0,react.useState)([]);
    // select
    const [selectLocations, setSelectLocations] = (0,react.useState)({});
    let Basic = window.localStorage.getItem("Basic");
    Basic = Basic == null || Basic == 0 ? true : false;
    // 获取地理位置
    let location = async (latitude, longitude)=>{
        try {
            let result = await (0,axios/* default */.Z)({
                url: "".concat("https://api.bigdatacloud.net/data/reverse-geocode-client", "?latitude=").concat(latitude, "&longitude=").concat(longitude),
                method: "get"
            });
            let location = "".concat(result.data.countryName, " ").concat(result.data.city, " ").concat(result.data.locality);
            return "".concat(location);
        } catch (error) {
            return "";
        }
    };
    const [targetDeviceList, setTargetDeviceList] = (0,react.useState)([]);
    // 获取设备信息
    const getTargetDeviceList = async ()=>{
        var ref;
        const deviceUsername = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        if (!deviceUsername) return;
        let { data: result  } = await (0,dashboard/* getAllDashboard */.gP)({
            username: deviceUsername,
            params: {
                category: "USER_SUMMARY"
            }
        });
        const advance = result === null || result === void 0 ? void 0 : (ref = result.summary) === null || ref === void 0 ? void 0 : ref.advance;
        if (advance != null) {
            let data = advance.map((row)=>{
                if (row.device.snapshots != null) {
                    return {
                        device_name: row.device.device_name || "",
                        product_type: row.device.product_type || "",
                        serial_number: row.device.serial_number || "",
                        unique_identifier: row.device.unique_identifier || "",
                        product_version: row.device.snapshots[row.device.snapshots.length - 1].product_version,
                        updated_at: dayjs_min_default()(row.device.snapshots[row.device.snapshots.length - 1].updated_at).format("YYYY-MM-DD HH:mm"),
                        size: (0,byteConversion/* default */.Z)(row.device.snapshots[row.device.snapshots.length - 1].size)
                    };
                } else {
                // return {
                //   device_name: row.device.device_name || '',
                //   product_type: row.device.product_type || '',
                //   serial_number: row.device.serial_number || '',
                //   product_version: '',
                //   updated_at: '',
                //   size: ''
                // }
                }
            });
            setTargetDeviceList(data.filter((row)=>row));
        }
    };
    (0,react.useEffect)(()=>{
        let deviceUsername = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        if (!deviceUsername || Basic != false) return;
        let timer;
        try {
            const setCallData = async ()=>{
                if (!deviceUsername) return;
                let check = await (0,dashboard/* getCallHistory */._e)({
                    username: deviceUsername,
                    params: {
                        category: "CONTACT",
                        offset: 0,
                        limit: 1
                    }
                });
                // 如果账号过期了,不在执行下面
                if (check.code === 1002) return;
                let { data: allData , advanced  } = await (0,dashboard/* getAllDashboard */.gP)({
                    username: deviceUsername,
                    params: {
                        category: "USER_SUMMARY"
                    }
                });
                dispatch((0,Common/* changeExtremeService */.xU)(advanced === true || advanced === "true")) // 更新高级服务状态
                ;
                const summary = allData === null || allData === void 0 ? void 0 : allData.summary;
                if (!summary || typeof summary !== "object") return;
                // 判断基础数据下载了没
                for(let key in summary){
                    if (key != "advance" && summary[key] > 0) {
                        localStorage.setItem("BasicTips", "1");
                    }
                }
                // 获取所有列表数据
                let list = allIcon;
                var ref;
                // let list2 = _iconList
                // 赋值基础数据
                list[0] && (list[0].num = (ref = summary === null || summary === void 0 ? void 0 : summary.photo) !== null && ref !== void 0 ? ref : 0);
                var ref1;
                list[1] && (list[1].num = (ref1 = summary === null || summary === void 0 ? void 0 : summary.video) !== null && ref1 !== void 0 ? ref1 : 0);
                var ref2;
                list[2] && (list[2].num = (ref2 = summary === null || summary === void 0 ? void 0 : summary.location) !== null && ref2 !== void 0 ? ref2 : 0);
                var ref3;
                list[3] && (list[3].num = (ref3 = summary === null || summary === void 0 ? void 0 : summary.contact) !== null && ref3 !== void 0 ? ref3 : 0);
                var ref4;
                list[4] && (list[4].num = (ref4 = summary === null || summary === void 0 ? void 0 : summary.mail) !== null && ref4 !== void 0 ? ref4 : 0);
                var ref5;
                list[5] && (list[5].num = (ref5 = summary === null || summary === void 0 ? void 0 : summary.drive) !== null && ref5 !== void 0 ? ref5 : 0);
                var ref6;
                list[6] && (list[6].num = (ref6 = summary === null || summary === void 0 ? void 0 : summary.note) !== null && ref6 !== void 0 ? ref6 : 0);
                var ref7;
                list[7] && (list[7].num = (ref7 = summary === null || summary === void 0 ? void 0 : summary.event) !== null && ref7 !== void 0 ? ref7 : 0);
                var ref8;
                list[8] && (list[8].num = (ref8 = summary === null || summary === void 0 ? void 0 : summary.reminder) !== null && ref8 !== void 0 ? ref8 : 0);
                // 旧icon顺序基础数据赋值
                // list[19] && (list[19].num = allData?.summary?.calendar)
                // list[9] && (list[9].num = allData?.summary?.contact)
                // list[15] && (list[15].num = allData?.summary?.drive)
                // list[3] && (list[3].num = allData?.summary?.location)
                // list[16] && (list[16].num = allData?.summary?.note)
                // list[1] && (list[1].num = allData?.summary?.photo)
                // list[18] && (list[18].num = allData?.summary?.reminder)
                // list[4] && (list[4].num = allData?.summary?.video)
                // list2[3].num = allData.summary.location
                // list2[4].num = allData.summary.photo
                // list2[5].num = allData.summary.video
                // 根据设备id获取高级数据
                let deviceUdid = JSON.parse(localStorage.getItem("currentDevice")) != null ? JSON.parse(localStorage.getItem("currentDevice"))["Unique Identifier"] : "";
                if (summary.advance != null) {
                    try {
                        let find = summary.advance.find((row)=>{
                            if (row.device != null && row.device.unique_identifier == deviceUdid) {
                                return row;
                            }
                        });
                        if (find) {
                            list[9].num = find.sms;
                            list[10].num = find.call;
                            list[11].num = find.voicemail;
                            list[12].num = find.whatsapp;
                            list[13].num = find.whatsapp_smb;
                            list[14].num = find.line;
                            list[15].num = find.kik;
                            list[16].num = find.wechat;
                            list[17].num = find.facebook_messenger;
                            list[18].num = find.safari_history;
                            list[19].num = find.safari_bookmark;
                            list[20].num = find.app;
                            list[21].num = find.wifi;
                            list[22].num = find.skype_interaction;
                            list[23].num = find.teams_interaction;
                            list[24].num = find.telegram_interaction;
                            list[25].num = find.snapchat_interaction;
                            list[26].num = find.instagram_interaction;
                            list[27].num = find.facetime_interaction;
                        // 旧icon顺序高级数据赋值
                        // list[6].num = find.call
                        // list[12].num = find.app
                        // list[5].num = find.line
                        // list[8].num = find.facebook_messenger
                        // list[11].num = find.kik
                        // list[10].num = find.safari_bookmark
                        // list[7].num = find.safari_history
                        // list[0].num = find.sms
                        // list[14].num = find.wechat
                        // list[2].num = find.whatsapp
                        // list[13].num = find.wifi
                        // list[17].num = find.whatsapp_smb
                        // list[20].num = find.skype_interaction
                        // list[21].num = find.teams_interaction
                        // list[22].num = find.telegram_interaction
                        // list[23].num = find.snapchat_interaction
                        // list[24].num = find.instagram_interaction
                        // list[25].num = find.facetime_interaction
                        // list2[0].num = find.sms
                        // list2[1].num = find.whatsapp
                        // list2[2].num = find.facebook_messenger
                        // list2[6].num = find.call
                        // list2[7].num = find.safari_history
                        // list2[8].num = find.snapchat_interaction
                        }
                        let _isHasData = false;
                        Object.keys(find).forEach((key)=>{
                            if (key != "device") {
                                if (find[key]) {
                                    _isHasData = true;
                                }
                            }
                        });
                        setIsInviteComment(_isHasData);
                    } catch (error) {}
                }
                localStorage.setItem("userSummary", JSON.stringify(list));
                setList([
                    ...list
                ]);
                // setIconList(list2)
                // 处理message数据
                let message = await (0,dashboard/* getAllDashboard */.gP)({
                    username: deviceUsername,
                    params: {
                        category: "SMS_CHAT_SUMMARY",
                        offset: 0,
                        limit: 4,
                        deviceUdid: deviceUdid
                    }
                });
                // 处理message数据
                setMessages(message.data.contents != null ? message.data.contents : []);
                // 处理安装app
                let app = await (0,dashboard/* getAllDashboard */.gP)({
                    username: deviceUsername,
                    params: {
                        category: "INSTALLED_APP",
                        offset: 0,
                        limit: 4,
                        deviceUdid: deviceUdid
                    }
                });
                setInstalledApp(app.data.contents != null ? app.data.contents.slice(0, 4) : []);
                // 处理位置
                let reqLocation = await (0,dashboard/* getAllDashboard */.gP)({
                    username: deviceUsername,
                    params: {
                        category: "LOCATION",
                        offset: 0,
                        limit: 4,
                        deviceUdid: deviceUdid
                    }
                });
                if (reqLocation.data.contents == null) {
                    setLocations([]);
                } else {
                    let storageLocations = JSON.parse(localStorage.getItem("gpsLocations")) || [];
                    let locationResult = reqLocation.data.contents;
                    for(let i = 0; i < locationResult.length; i++){
                        locationResult[i].id = i + 1;
                        locationResult[i].lat = locationResult[i].latitude;
                        locationResult[i].lng = locationResult[i].longitude;
                        locationResult[i].time = dayjs_min_default()(locationResult[i].timeStamp).format("D MMM,hh:mm a");
                        locationResult[i].position = await location("".concat(locationResult[i].latitude), "".concat(locationResult[i].longitude));
                    }
                    setDefaultProps(locationResult[0]);
                    setSelectLocations(locationResult[0]);
                    setLocations(locationResult);
                }
            };
            setCallData();
            // 延迟获取高级数据
            timer = setTimeout(()=>{
                setCallData();
                getTargetDeviceList();
            }, 3000);
        } catch (error) {
            ;
        }
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, []);
    // 数据量最多的常用app列表
    const [frequentlyArr, setFrequentlyArr] = (0,react.useState)([]);
    const [basicArr, setBasicArr] = (0,react.useState)([]) // 基础服务app列表
    ;
    const [extremeArr, setExtremeArr] = (0,react.useState)([]) // 高级服务app列表
    ;
    const [innerWidth, setInnerWidth] = (0,react.useState)(0) // 实时屏幕宽度
    ;
    // 监听屏幕宽度变化
    (0,react.useEffect)(()=>{
        if (true) {
            const handlerResize = ()=>{
                setInnerWidth(window.innerWidth);
            };
            handlerResize();
            window.addEventListener("resize", handlerResize);
            return ()=>{
                window.removeEventListener("resize", handlerResize);
            };
        }
    }, []);
    //初始化列表
    (0,react.useEffect)(()=>{
        if (useList && useList.length > 0) {
            // 增值服务上线前付费用户展示数据，移动端的常用app为数量倒序，其他的hot app未排序
            if (innerWidth < 780) {
                // 过滤出指定 name 的 icon 并按 num 值降序排序
                let selectedIcons = useList.filter((icon)=>{
                    return [
                        "Text message",
                        "WhatsApp",
                        "Messenger",
                        "Locations",
                        "Photo",
                        "Video",
                        "Call",
                        "Browser Bookmark",
                        "Snapchat"
                    ].includes(icon.name) && icon.num > 0;
                });
                // if (selectedIcons.length === 0) {
                //   return
                // }
                // 过滤出不在 selectedIcons 中的其他 icon 并按 num 值降序排序
                let _selectedIcons = useList.filter((icon)=>!([
                        "Text message",
                        "WhatsApp",
                        "Messenger",
                        "Locations",
                        "Photo",
                        "Video",
                        "Call",
                        "Browser Bookmark",
                        "Snapchat"
                    ].includes(icon.name) && icon.num > 0)).sort((a, b)=>b.num - a.num);
                setCloneList([
                    ...selectedIcons,
                    ..._selectedIcons
                ].slice(0, 9));
                setFrequentlyArr([
                    ...selectedIcons,
                    ..._selectedIcons
                ].sort((a, b)=>b.num - a.num).slice(0, 3));
            } else {
                setCloneList(useList);
                setFrequentlyArr([
                    ...useList
                ].sort((a, b)=>b.num - a.num).slice(0, 3));
            }
            // 基础服务map映射
            const basicMap = new Map([
                "Photo",
                "Video",
                "Locations",
                "Contact",
                "Mail",
                "iCloud drive",
                "Note",
                "Calendar",
                "Reminder"
            ].map((item)=>[
                    item,
                    null
                ]));
            // 增值服务map映射
            const extremeMap = new Map([
                "Text message",
                "Call",
                "Voicemail",
                "WhatsApp",
                "WA Business",
                "Line",
                "Kik",
                "WeChat",
                "Messenger",
                "Browser history",
                "Browser Bookmark",
                "Install Apps",
                "Wi-Fi network",
                "Skype",
                "Teams",
                "Telegram",
                "Snapchat",
                "Instagram",
                "Facetime"
            ].map((item)=>[
                    item,
                    null
                ]));
            // 遍历处理后的功能数据统计，填充到对应的分区
            useList.forEach((item)=>{
                if (basicMap.has(item.name)) {
                    basicMap.set(item.name, item);
                }
                if (extremeMap.has(item.name)) {
                    extremeMap.set(item.name, item);
                }
            });
            const basicArr = Array.from(basicMap.values());
            setBasicArr(basicArr);
            const extremeArr = Array.from(extremeMap.values());
            setExtremeArr(extremeArr);
        }
    }, [
        useList,
        innerWidth
    ]);
    let currentDevice = JSON.parse(window.localStorage.getItem("currentDevice"));
    if (currentDevice == null) {
        currentDevice = {
            "Build Version": "",
            "Device Name": "",
            "Product Type": "",
            "Serial Number": ""
        };
    }
    const [defaultProps, setDefaultProps] = (0,react.useState)({
        center: {
            lat: 40.73061,
            lng: -73.935242
        },
        zoom: 14
    });
    const [tips, setTips] = (0,react.useState)(false);
    const switchDev = async ()=>{
        let check = await (0,login.userDeviceCurrent)();
        if (check.all.includes("android")) {
            localStorage.removeItem("DeviceUser");
            localStorage.setItem("currentMode", "android");
            router.push("/android" + window.location.pathname);
        } else {
            setTips(true);
        }
    };
    // 显示布局选项
    const [layoutCurdOpen, setLayoutCurdOpen] = (0,react.useState)(false);
    // 全部类型
    const [layoutOptions, setLayoutOptions] = (0,react.useState)([]);
    // 打开布局
    const handleLayout = ()=>{
        setLayoutCurdOpen(true);
        // 过滤
        let all = (0,vertical/* default */.Z)().filter((row)=>{
            let filter = [
                "Dashboard",
                "My account",
                "GPS location"
            ];
            if (typeof row.title != "undefined" && !filter.includes(row.title)) {
                return row;
            }
        });
        all = all.map((row)=>{
            return {
                ...row,
                label: row.title,
                value: row.path,
                icon: ""
            };
        });
        setLayoutOptions(all);
    };
    // 保存选项
    const [saveLayout, setSaveLayout] = (0,react.useState)([]);
    // 处理选项
    const layoutChange = (e)=>{
        let save = JSON.parse(JSON.stringify(saveLayout));
        if (save.length == 3) {
            save = save.slice(1, 3);
        }
        setSaveLayout([
            ...save,
            {
                title: e.title,
                path: e.path,
                category: e.category
            }
        ]);
    };
    // 发送保存选项
    const sendSaveLayout = async ()=>{
        setLayoutCurdOpen(false);
        await (0,login.sendLikeType)({
            likeType: saveLayout,
            username: JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : ""
        });
    };
    (0,react.useEffect)(()=>{
        let likeType = localStorage.getItem("DeviceUser");
    }, []);
    (0,react.useEffect)(()=>{
        dispatch((0,Common/* setCurrentTab */.Lw)(t("Dashboard")));
        return ()=>dispatch((0,Common/* setCurrentTab */.Lw)(""));
    }, [
        dispatch,
        locale
    ]);
    (0,react.useEffect)(()=>{
        (0,login.getUserAccountOrder)({
            page: 1,
            pageSize: 10
        });
    }, []);
    const conversionUtcDate = function(date, type) {
        let format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "YYYY-MM-DD HH:mm:ss";
        if (type === "local") {
            // 传入local则将UTC时间转换为本地时间
            return dayjs_min_default().utc(date).local().format(format);
        } else if (type === "UTC") {
            // 传入UTC则将时间转换为UTC时间
            return dayjs_min_default()(date).utc().format();
        }
    };
    function handlerDateDurationCurrent(time) {
        if (new Date(time) < new Date()) {
            return 0;
        }
        let d1 = new Date(time);
        let d2 = new Date();
        let cha = Math.abs(d2.getTime() - d1.getTime());
        let days = parseInt(cha / (24 * 60 * 60 * 1000));
        let hours = parseInt(cha % (24 * 60 * 60 * 1000) / (60 * 60 * 1000));
        let mins = parseInt(cha % (60 * 60 * 1000) / (60 * 1000));
        if (days) {
            return " ".concat(days, "d");
        } else if (hours) {
            return "+ ".concat(hours, "h ").concat(mins, "m");
        } else {
            return "+ ".concat(mins, "m");
        }
    }
    const [orderListData, setOrderListData] = (0,react.useState)({});
    // 当前设备的平台类型，取【设备接口】user-device，不用订单的 platform_type（后者不准）
    const [currentDevicePlatform, setCurrentDevicePlatform] = (0,react.useState)("");
    const [orderList, setOrderList] = (0,react.useState)([]);
    const [notBindICloud, setNotBindICloud] = (0,react.useState)(false) // 增值服务上线前付费且从未绑定过iCloud
    ;
    const setOrderData = async ()=>{
        const res = await (0,login.getUserAccountOrder)({
            page: 1,
            pageSize: 9999
        });
        const orders = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
        let deviceUser = {};
        try {
            deviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "{}") || {};
        } catch (e) {
            deviceUser = {};
        }
        const username = deviceUser.username || "";
        orders.forEach((item, index)=>{
            const accountNumber = (index + 1).toString().padStart(2, "0");
            item.name = "Account".concat(accountNumber);
        });
        setOrderList(orders);
        // 设备接口（user-device）记录：带 order_id（后端指明这台设备当前是哪张单）与 platform_type。
        // 侧栏 / 刷新到期时间时都会把它写进 allDeviceUser，这里直接读缓存，不额外打接口。
        let currentDevice = null;
        try {
            const cachedDevices = JSON.parse(localStorage.getItem("allDeviceUser") || "[]");
            currentDevice = (0,refreshSubscriptionExpire/* matchCurrentDevice */.pG)(Array.isArray(cachedDevices) ? cachedDevices : [], deviceUser);
        } catch (e1) {
            currentDevice = null;
        }
        setCurrentDevicePlatform((currentDevice === null || currentDevice === void 0 ? void 0 : currentDevice.platform_type) || "");
        // 只取【当前设备】的关联订单：
        // 优先用设备上的 order_id 直接命中订单主键；没有 order_id 才按 device_id / iCloud 账号找，
        // 且同一设备有多张单时取过期时间最晚的那张（最新的关联单）。
        // 不能用「全局过期最晚的一张」——那会把别的设备（例如安卓单）的到期时间和
        // Basic/Extreme 档位显示到当前设备上。
        const currentOrder = (0,utils_currentOrder/* resolveDeviceOrder */.mw)({
            orders,
            deviceUser,
            device: currentDevice
        });
        // 展示字段以【设备接口】为准：user-device 现在直接返回
        // order_id / product_name / order_level / expire_time，就是这台设备当前的订阅状态；
        // 订单只用于补设备接口没有的字段（如 merchant_no）。
        const cardOrder = (0,utils_currentOrder/* resolveCardSubscription */.Xm)({
            order: currentOrder,
            device: currentDevice
        });
        var _id;
        const result = cardOrder.expire_time ? {
            ...cardOrder,
            key: (_id = cardOrder.id) !== null && _id !== void 0 ? _id : currentDevice === null || currentDevice === void 0 ? void 0 : currentDevice.order_id,
            createdAt: conversionUtcDate(cardOrder.createdAt, "local"),
            expire_time: conversionUtcDate(cardOrder.expire_time, "local", "YYYY-MM-DD"),
            remainingDays: handlerDateDurationCurrent(cardOrder.expire_time)
        } : {};
        setOrderListData(result);
        setNotBindICloud(!username) // 设置用户是否绑定过设备
        ;
    // 增值服务之前付费用户状态更改
    };
    (0,react.useEffect)(()=>{
        setOrderData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        deviceRequestKey
    ]);
    // 延长续订
    const [extendSubscriptionModal, setExtendSubscriptionModal] = (0,react.useState)(false);
    const extendSubscription = async ()=>{
        try {
            const renewId = await (0,renewalPlans/* fetchRenewProductIdForOrder */.R4)(orderListData);
            if (!renewId) {
                window.dispatchEvent(new Event("renewalFailed"));
                (0,Message/* messageInfo */.B)({
                    content: t("Payment failed"),
                    duration: 6
                });
                return;
            }
            const result = await (0,dashboard/* extendSubscriptionTime */.rK)({
                merchant_no: orderListData.merchant_no,
                renewId,
                order_type: 274
            });
            // HTTP 200 但业务 code 非 0 也属于续费失败；通知全局续费组件展示新支付方式兜底弹窗。
            if (Number(result === null || result === void 0 ? void 0 : result.code) !== 0) {
                (0,Message/* messageInfo */.B)({
                    content: "".concat(result.msg),
                    duration: 6
                });
                window.dispatchEvent(new Event("renewalFailed"));
                return;
            }
            // 续费成功：先给用户可感知的反馈，再整页刷新。
            // 不做局部刷新是因为覆盖不全：ExpirationReminder 的 banner 依赖 Redux 的 deviceUser，
            // 而 refreshSubscriptionExpire 只 bump deviceSwitchRevision、不动 deviceUser，
            // 过期 banner / 遮罩可能仍停在「已过期」视图。
            // 整页刷新最稳，也与 ExpiredPurchaseGuide 的成功处理保持一致。
            (0,Message/* messageInfo */.B)({
                content: "".concat(result.msg),
                duration: 1.5
            });
            (0,refreshSubscriptionExpire/* reloadAfterRenewSuccess */.dZ)();
        } catch (error) {
            var ref, ref1;
            ;
            (0,Message/* messageInfo */.B)({
                content: (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.msg) || (error === null || error === void 0 ? void 0 : error.msg) || t("Payment failed"),
                duration: 6
            });
            window.dispatchEvent(new Event("renewalFailed"));
        } finally{
            setExtendSubscriptionModal(false);
        }
    };
    const openNav = ()=>{
        dispatch((0,Common/* toggleNavVisibility */.m_)(true));
    };
    // 处理订阅月份显示文字
    const handlerPlanText = (name)=>{
        if (!name) return "";
        const match = name.match(/\d+/g) // 提取月份数字部分
        ;
        const months = match ? Number(match[0]) : 1 // 默认值为1，防止 undefined
        ;
        return months >= 3 ? name : name.replace("Months", "Month");
    };
    // ===== 首页 Extreme 升级弹窗 =====
    // 判断口径与功能页一致，但这里只取结果、不触发「未绑高级跳验证页」的跳转，
    // 避免把用户从首页带到验证页。
    const extremeGateApplies = (0,iosIcloudBindStatus/* shouldApplyIosExtremeBindGate */.yI)(store.currentMode);
    const extremeResetPending = extremeGateApplies && (0,iosIcloudBindStatus/* isResetTimePending */.z6)(store.resetTime);
    const extremeBindIncomplete = extremeGateApplies && (0,iosIcloudBindStatus/* isAdvancedVerificationIncomplete */.dU)(store.resetTime);
    const hasExtremePlan = store.extremeService === true || store.extremeService === "true";
    // 续费优先：已过期（宽限期）或 7 天内到期时，不弹升级
    const currentDeviceRow = (()=>{
        try {
            return JSON.parse(localStorage.getItem("DeviceUser") || "null");
        } catch (e) {
            return null;
        }
    })();
    const currentDeviceStatus = (0,subscriptionStatus/* resolveDeviceSubscriptionStatus */.MA)(currentDeviceRow || {});
    var ref1;
    const currentDeviceExpireMs = (0,subscriptionExpire/* parseExpireMs */.EI)((ref1 = (0,subscriptionExpire/* resolveDeviceExpireTime */.ku)(currentDeviceRow)) !== null && ref1 !== void 0 ? ref1 : currentDeviceRow === null || currentDeviceRow === void 0 ? void 0 : currentDeviceRow.expire_time);
    const renewalTakesPriority = currentDeviceStatus === subscriptionStatus/* SUBSCRIPTION_STATUS.GRACE */.qq.GRACE || currentDeviceStatus === subscriptionStatus/* SUBSCRIPTION_STATUS.LAPSED */.qq.LAPSED || Number.isFinite(currentDeviceExpireMs) && currentDeviceExpireMs - Date.now() <= 7 * 24 * 60 * 60 * 1000;
    // 关闭后当天不再弹（按设备记录）
    const upgradeDismissKey = "extremeUpgradeDismissed-".concat(store.deviceUser || "");
    const readUpgradeDismissed = (key)=>{
        try {
            return localStorage.getItem(key) === dayjs_min_default()().format("YYYY-MM-DD");
        } catch (e) {
            return false;
        }
    };
    // 首屏/切设备时同步读取当天记录，避免「先闪一下弹窗再消失」
    const [upgradeDismiss, setUpgradeDismiss] = (0,react.useState)(()=>({
            key: upgradeDismissKey,
            dismissed: readUpgradeDismissed(upgradeDismissKey)
        }));
    if (upgradeDismiss.key !== upgradeDismissKey) {
        setUpgradeDismiss({
            key: upgradeDismissKey,
            dismissed: readUpgradeDismissed(upgradeDismissKey)
        });
    }
    // 首页需要高级绑定状态才能判断是否该弹升级窗；功能页各自拉取，这里补一次（仅 iOS-Cloud）
    (0,react.useEffect)(()=>{
        if (!extremeGateApplies || !store.deviceUser) return;
        dispatch((0,Common/* fetchResetTime */.NZ)());
    }, [
        dispatch,
        extremeGateApplies,
        store.deviceUser,
        store.deviceSwitchRevision
    ]);
    const closeUpgradeModal = ()=>{
        setUpgradeDismiss({
            key: upgradeDismissKey,
            dismissed: true
        });
        try {
            localStorage.setItem(upgradeDismissKey, dayjs_min_default()().format("YYYY-MM-DD"));
        } catch (e) {
        // localStorage 不可用时仅本次会话内关闭，不影响页面
        }
    };
    const showDashboardUpgrade = extremeGateApplies && !extremeResetPending && !extremeBindIncomplete && !hasExtremePlan && !renewalTakesPriority && !upgradeDismiss.dismissed;
    // 卡片上的 Product 一律以【设备接口】的平台类型为准，
    // 订单接口的 platform_type 表示「买的产品」，不等于当前设备类型。
    const cardPlatformType = currentDevicePlatform || (orderListData === null || orderListData === void 0 ? void 0 : orderListData.platform_type) || "";
    const currentDeviceUdid = ((ref = JSON.parse(localStorage.getItem("currentDevice") || "null")) === null || ref === void 0 ? void 0 : ref["Unique Identifier"]) || "";
    const currentTargetDevice = targetDeviceList.find((item)=>item.unique_identifier === currentDeviceUdid) || targetDeviceList[0] || null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            userSelect: "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstBinding/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpirationReminder/* default */.Z, {
                orders: orderList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(extreme_upgrade/* default */.ZP, {
                open: showDashboardUpgrade,
                onClose: closeUpgradeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 6,
                sx: {},
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    md: 12,
                    lg: 12,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                            style: {
                                width: "100%",
                                marginBottom: "20px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full flex justify-between items-center mb-[26px] Mlg:mb-0 pt-[24px] Mlg:pt-[16px] pl-[40px] Mlg:pl-[16px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-[18px] text-[#222] font-[600] leading-[27px]",
                                        children: t("Basic Features")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                    style: {
                                        display: "flex",
                                        flexWrap: "wrap"
                                    },
                                    sx: {
                                        "@media (min-width: 768px)": {
                                            padding: "0px !important"
                                        },
                                        "@media (max-width: 768px)": {
                                            padding: "22px !important"
                                        }
                                    },
                                    children: basicArr.map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 4,
                                            md: 3,
                                            lg: 2,
                                            className: "sm:hidden",
                                            style: {
                                                position: "relative",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            },
                                            sx: {
                                                "@media (min-width: 768px)": {
                                                    marginBottom: "50px !important"
                                                },
                                                "@media (max-width: 768px)": {
                                                    marginBottom: "30px !important"
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                className: "flex flex-col items-center justify-center",
                                                href: row.href,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-[50px] h-[50px] relative",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: row.img,
                                                                alt: "img",
                                                                width: 50,
                                                                height: 50,
                                                                className: "mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center",
                                                                children: row.num
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mt-[10px] text-[16px] Mlg:text-[12px] text-[#2E2E2E] leading-[24px] Mlg:leading-[21px] w-full text-center",
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: t(row.name)
                                                    })
                                                ]
                                            })
                                        }, row.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card_Card/* default */.Z, {
                            style: {
                                width: "100%",
                                marginBottom: "20px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full flex justify-between items-center mb-[26px] Mlg:mb-0 pt-[24px] Mlg:pt-[16px] pl-[40px] Mlg:pl-[16px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: "text-[18px] text-[#222] font-[600] leading-[27px]",
                                        children: [
                                            "Extreme\xa0",
                                            t("Features")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent_CardContent/* default */.Z, {
                                    style: {
                                        display: "flex",
                                        flexWrap: "wrap"
                                    },
                                    sx: {
                                        "@media (min-width: 768px)": {
                                            padding: "0px !important"
                                        },
                                        "@media (max-width: 768px)": {
                                            padding: "22px !important"
                                        }
                                    },
                                    children: extremeArr.map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 4,
                                            md: 3,
                                            lg: 2,
                                            className: "sm:hidden",
                                            style: {
                                                position: "relative",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            },
                                            sx: {
                                                "@media (min-width: 768px)": {
                                                    marginBottom: "50px !important"
                                                },
                                                "@media (max-width: 768px)": {
                                                    marginBottom: "30px !important"
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                className: "flex flex-col items-center justify-center",
                                                href: row.href,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-[50px] h-[50px] relative",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: row.img,
                                                                alt: "img",
                                                                width: 50,
                                                                height: 50,
                                                                className: "mx-auto p-2 rounded-[14px] bg-[#F0F1F5] relative"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center",
                                                                children: row.num
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "mt-[10px] text-[16px] Mlg:text-[12px] text-[#2E2E2E] leading-[24px] Mlg:leading-[21px] w-full text-center",
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: t(row.name)
                                                    })
                                                ]
                                            })
                                        }, row.id))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-3 Hsm:grid-cols-2 Hsm:Dsm:grid-cols-1 w-full Dmd:gap-[20px] Hsm:Dsm:gap-y-[20px] mt-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[30px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-[18px] text-[#222] font-[600]",
                                        children: t("Account")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hover:cursor-pointer",
                                        ref: toggleButtonRef,
                                        onClick: (event)=>{
                                            event.stopPropagation() // 阻止事件冒泡
                                            ;
                                            setShowOrderList((prev)=>!prev) // 确保状态切换
                                            ;
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            className: "w-[24px] h-[24px]",
                                            src: "/images/change-password/drop-down.svg",
                                            width: 24,
                                            height: 24,
                                            alt: "drop down"
                                        })
                                    }),
                                    showOrderList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: orderListRef,
                                        className: "bg-[#FFF] w-full absolute left-0 top-[40px] z-10 rounded-[8px] p-[8px] drop-shadow-[0_4px_8px_rgba(0,0,0,0.13)] overflow-auto",
                                        children: orderList.map((row, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: ()=>changeOrder(row, index),
                                                className: "hover:bg-[#F4F5F6] hover:cursor-pointer px-[15px] py-[10px] ".concat(orderIndex === index ? "bg-[#F4F5F6]" : ""),
                                                children: row.name
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-[1px] bg-[#E5E5E5] mt-[20px] mb-[24px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full h-[108px] flex flex-col justify-between text-[14px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#334062]",
                                                children: [
                                                    t("Product"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#9198AD]",
                                                children: cardPlatformType
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#334062]",
                                                children: [
                                                    t("Subscription Plan"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#9198AD]",
                                                children: [
                                                    (0,orderLevel/* isBasicOrderLevel */.$w)(orderListData === null || orderListData === void 0 ? void 0 : orderListData.order_level) ? "".concat(t("Basic"), " - ") : "Extreme - ",
                                                    handlerPlanText(orderListData.product_name)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full flex justify-between items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#334062]",
                                                children: [
                                                    t("Expiry Date"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#9198AD]",
                                                children: dayjs_min_default()(orderListData.expire_time).format("YYYY-MM-DD")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "text-[#454CFF] w-full h-[45px] border border-[#454CFF] rounded-[22.5px] mt-[36px] hover:bg-[#454CFF] hover:text-[#FFF]",
                                onClick: ()=>setExtendSubscriptionModal(true),
                                children: t("Extend subscription")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[24px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-[18px] text-[#222] font-[600] mb-[20px]",
                                children: t("Target Device Info")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full min-h-[54px] bg-[#F4F5F6] rounded-[8px] pl-[8px] pr-[14px] flex items-center text-[#334062] text-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "mb-[2px]",
                                        src: "/images/dashboard/apple_logo.svg",
                                        width: 24,
                                        height: 24,
                                        alt: "apple logo"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ml-[10px] w-full break-all",
                                        children: currentTargetDevice === null || currentTargetDevice === void 0 ? void 0 : currentTargetDevice.device_name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full h-[152px] mt-[24px] flex flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full flex justify-between items-center text-[14px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#334062]",
                                                children: "IMEI:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#9198AD]",
                                                children: currentTargetDevice === null || currentTargetDevice === void 0 ? void 0 : currentTargetDevice.serial_number
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full flex justify-between items-center text-[14px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#334062]",
                                                children: [
                                                    t("iOS version"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#9198AD]",
                                                children: currentTargetDevice === null || currentTargetDevice === void 0 ? void 0 : currentTargetDevice.product_version
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full flex justify-between items-center text-[14px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#334062]",
                                                children: [
                                                    t("Last backup time"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#9198AD]",
                                                children: currentTargetDevice === null || currentTargetDevice === void 0 ? void 0 : currentTargetDevice.updated_at
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full flex justify-between items-center text-[14px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-[#334062]",
                                                children: [
                                                    t("Last backup size"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#9198AD]",
                                                children: currentTargetDevice === null || currentTargetDevice === void 0 ? void 0 : currentTargetDevice.size
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default */.Z, {
                open: tips,
                onCancel: ()=>setTips(false),
                footer: [],
                zIndex: 1200,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: t("Currently you have only purchased the iPhone monitoring package If you want to monitor an Android device please click the button")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            textAlign: "center",
                            marginTop: "20px",
                            padding: "8px 22px",
                            borderRadius: "10px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            target: "_blank",
                            href: "https://test-ms-web.gbyte.com.cn" + "/choose-monitored-device",
                            style: {
                                background: "#07273D",
                                color: "#fff",
                                padding: "7px 14px",
                                borderRadius: "10px"
                            },
                            children: t("Add an Android device")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default */.Z, {
                open: layoutCurdOpen,
                footer: [],
                zIndex: 1200,
                closable: false,
                width: 700,
                className: "equipment",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            background: "#E7E7E7",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0 10px",
                            borderTopRightRadius: "8px",
                            borderTopLeftRadius: "8px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                style: {
                                    color: "#000000",
                                    fontSize: "22px"
                                },
                                children: t("choose 3 you like type")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                icon: "ic:round-cancel",
                                color: "#494949",
                                style: {
                                    fontSize: "18px",
                                    cursor: "pointer"
                                },
                                onClick: ()=>setLayoutCurdOpen(false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: layoutOptions.map((row, i)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_checkbox/* default */.Z, {
                                style: {
                                    margin: "4px",
                                    width: "150px"
                                },
                                checked: saveLayout.find((item)=>item.path == row.path),
                                onChange: ()=>layoutChange(row),
                                children: row.label
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            margin: "0 auto",
                            marginTop: "16px",
                            width: "60px",
                            height: "30px",
                            lineHeight: "30px",
                            textAlign: "center",
                            background: "#2A99FF",
                            color: "#fff",
                            borderRadius: "10px"
                        },
                        onClick: ()=>{
                            sendSaveLayout();
                        },
                        children: "OK"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default */.Z, {
                open: extendSubscriptionModal,
                onCancel: ()=>setExtendSubscriptionModal(false),
                footer: [],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            marginTop: "10px",
                            fontWeight: "600"
                        },
                        children: t("After confirmation a new order will be produced to extend the equipment expiration time")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "14px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                onClick: ()=>extendSubscription(),
                                style: {
                                    marginRight: "10px"
                                },
                                children: t("Confirm")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                onClick: ()=>setExtendSubscriptionModal(false),
                                children: t("Cancel")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_dashboard = (Dashboard1);


/***/ }),

/***/ 70640:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const byteConversion = (limit)=>{
    var size = "";
    if (limit < 0.1 * 1024) {
        //小于0.1KB，则转化成B
        size = limit.toFixed(2) + " B";
    } else if (limit < 0.1 * 1024 * 1024) {
        //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + " KB";
    } else if (limit < 1024 * 1024 * 1024) {
        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + " MB";
    } else {
        //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + " GB";
    }
    var sizeStr = size + "" //转成字符串
    ;
    var index = sizeStr.indexOf(".") //获取小数点处的索引
    ;
    var dou = sizeStr.substr(index + 1, 2) //获取小数点后两位的值
    ;
    if (dou == "00") {
        //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
    }
    return size;
};
/* harmony default export */ __webpack_exports__["Z"] = (byteConversion);


/***/ }),

/***/ 23269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$w": function() { return /* binding */ isBasicOrderLevel; }
/* harmony export */ });
/* unused harmony export resolveOrderLevel */
/**
 * 订单等级（订阅档位）归一化。
 *
 * 后端 order_level 的取值：
 *   1 = 初级（Basic）
 *   2 = 高级（Extreme）
 *
 * 历史遗留：增值服务（初级 / 高级分档）上线之前，老用户买的产品包**没有分档**，
 * 这些订单的 order_level 为 null（少数情况下是字符串 'null'）。按业务约定，
 * 这类订单一律**视为 2（高级）**。
 *
 * 因此本函数只在**明确等于 1** 时返回 1，其余（null / 'null' / undefined /
 * 其他非法值）一律返回 2。
 *
 * 之所以显式归一化，而不是直接用 `Number(order_level) === 1`：
 * 后者虽然对 null 也"碰巧"得到 Extreme（Number(null) === 0），但那只是巧合，
 * 一旦有人把判断改成 `=== 2 ? 'Extreme' : 'Basic'` 就会把老用户错判成初级。
 *
 * @param {*} orderLevel - 订单接口返回的 order_level
 * @returns {1|2} 归一化后的档位
 */ const resolveOrderLevel = (orderLevel)=>Number(orderLevel) === 1 ? 1 : 2;
/**
 * 是否为初级（Basic）档位。
 * 历史老用户（order_level 为 null）按高级处理，这里返回 false。
 *
 * @param {*} orderLevel - 订单接口返回的 order_level
 * @returns {boolean}
 */ const isBasicOrderLevel = (orderLevel)=>resolveOrderLevel(orderLevel) === 1;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (resolveOrderLevel)));


/***/ }),

/***/ 74204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getScrollBarSize; },
/* harmony export */   "o": function() { return /* binding */ getTargetScrollBarSize; }
/* harmony export */ });
/* harmony import */ var _Dom_dynamicCSS__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44958);
/* eslint-disable no-param-reassign */

var cached;
function measureScrollbarSize(ele) {
  var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
  var measureEle = document.createElement('div');
  measureEle.id = randomId;

  // Create Style
  var measureStyle = measureEle.style;
  measureStyle.position = 'absolute';
  measureStyle.left = '0';
  measureStyle.top = '0';
  measureStyle.width = '100px';
  measureStyle.height = '100px';
  measureStyle.overflow = 'scroll';

  // Clone Style if needed
  var fallbackWidth;
  var fallbackHeight;
  if (ele) {
    var targetStyle = getComputedStyle(ele);
    measureStyle.scrollbarColor = targetStyle.scrollbarColor;
    measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;

    // Set Webkit style
    var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
    var width = parseInt(webkitScrollbarStyle.width, 10);
    var height = parseInt(webkitScrollbarStyle.height, 10);

    // Try wrap to handle CSP case
    try {
      var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
      var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
      (0,_Dom_dynamicCSS__WEBPACK_IMPORTED_MODULE_0__/* .updateCSS */ .hq)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
    } catch (e) {
      // Can't wrap, just log error
      console.error(e);

      // Get from style directly
      fallbackWidth = width;
      fallbackHeight = height;
    }
  }
  document.body.appendChild(measureEle);

  // Measure. Get fallback style if provided
  var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
  var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;

  // Clean up
  document.body.removeChild(measureEle);
  (0,_Dom_dynamicCSS__WEBPACK_IMPORTED_MODULE_0__/* .removeCSS */ .jL)(randomId);
  return {
    width: scrollWidth,
    height: scrollHeight
  };
}
function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }
  if (fresh || cached === undefined) {
    cached = measureScrollbarSize();
  }
  return cached.width;
}
function getTargetScrollBarSize(target) {
  if (typeof document === 'undefined' || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }
  return measureScrollbarSize(target);
}

/***/ }),

/***/ 7028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* unused harmony export resetUuid */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function getUseId() {
  // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
  var fullClone = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2))));
  return fullClone.useId;
}
var uuid = 0;

/** @private Note only worked in develop env. Not work in production. */
function resetUuid() {
  if (false) {}
}
var useOriginId = getUseId();
/* harmony default export */ __webpack_exports__["Z"] = (useOriginId ?
// Use React `useId`
function useId(id) {
  var reactId = useOriginId();

  // Developer passed id is single source of truth
  if (id) {
    return id;
  }

  // Test env always return mock id
  if (false) {}
  return reactId;
} :
// Use compatible of `useId`
function useCompatId(id) {
  // Inner id for accessibility usage. Only work in client side
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState('ssr-id'),
    _React$useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState, 2),
    innerId = _React$useState2[0],
    setInnerId = _React$useState2[1];
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var nextId = uuid;
    uuid += 1;
    setInnerId("rc_unique_".concat(nextId));
  }, []);

  // Developer passed id is single source of truth
  if (id) {
    return id;
  }

  // Test env always return mock id
  if (false) {}

  // Return react native id or inner id
  return innerId;
});

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3498,5675,5432,9830,5170,1954,1033,8914,2862,770,210,1664,2586,6456,6886,621,9145,4567,9166,5983,3769,9965,4593,726,9774,2888,179], function() { return __webpack_exec__(91015); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);